// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$resolve(url) {url = importMap[url] || url;return publicUrl + url;}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"iFN5Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Nav", ()=>Nav);
parcelHelpers.export(exports, "usePendingPage", ()=>usePendingPage);
parcelHelpers.export(exports, "SideNav", ()=>SideNav);
parcelHelpers.export(exports, "SideNavItem", ()=>SideNavItem);
parcelHelpers.export(exports, "SideNavLink", ()=>SideNavLink);
parcelHelpers.export(exports, "OnPageNav", ()=>OnPageNav);
parcelHelpers.export(exports, "MobileOnPageNav", ()=>MobileOnPageNav);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _library = require("./library");
var _navigationSuspense = require("./NavigationSuspense");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function isSectionMap(value) {
    return value instanceof Map;
}
function Nav({ pages, currentPage }) {
    let currentLibrary = (0, _library.getLibraryFromPage)(currentPage);
    let sections = new Map();
    let sectionLibrary = new Map();
    for (let page of pages){
        if (page.exports?.hideNav || page.exports?.omitFromNav) continue;
        let library = (0, _library.getLibraryFromPage)(page);
        if ((currentLibrary === 'internationalized' || currentLibrary === 'react-spectrum') && library !== currentLibrary) continue;
        // If the current library is React Aria, we only want to skip pages in React Spectrum so that include Internationalized pages in the side nav
        if (currentLibrary === 'react-aria' && library === 'react-spectrum') continue;
        let section = page.exports?.section ?? 'Components';
        let group = page.exports?.group ?? undefined;
        if (section === '') continue;
        if (group && section && currentLibrary !== 'internationalized') {
            let value = sections.get(group);
            let groupMap;
            if (value instanceof Map) groupMap = value;
            else groupMap = new Map();
            let groupPages = groupMap.get(section) ?? [];
            groupPages.push(page);
            groupMap.set(section, groupPages);
            sections.set(group, groupMap);
        } else if (section) {
            let value = sections.get(section);
            let sectionPages = Array.isArray(value) ? value : [];
            sectionPages.push(page);
            sections.set(section, sectionPages);
        }
        sectionLibrary.set(section, library);
    }
    let [maskSize, setMaskSize] = (0, _react.useState)(0);
    const snapshot = (0, _react.useSyncExternalStore)((0, _navigationSuspense.subscribe), (0, _navigationSuspense.getSnapshot), (0, _navigationSuspense.getSnapshot));
    const pendingPage = snapshot.pathname ? (0, _navigationSuspense.getPageFromPathname)(pages, snapshot.pathname) : null;
    let displayUrl = pendingPage?.url ?? currentPage.url;
    let sortedSections = [
        ...sections
    ].sort((a, b)=>{
        if (a[0] === 'Overview') return -1;
        if (b[0] === 'Overview') return 1;
        if (a[0] === 'Guides') return 1;
        if (b[0] === 'Guides') return -1;
        return a[0].localeCompare(b[0]);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
        onScroll: (e)=>setMaskSize(Math.min(e.currentTarget.scrollTop, 32)),
        style: {
            maskImage: maskSize > 0 ? `linear-gradient(to bottom, transparent, black ${maskSize}px)` : undefined
        },
        className: " _Pe12 WB12 FD12 KEqCbPc12 _Na12 Pa12 Se12 Re12 Ng12 sk12 spb12",
        children: sortedSections.map(([name, pages])=>{
            let nav = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
            if (isSectionMap(pages)) nav = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: Array.from(pages.entries()).map(([section, items])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavSection, {
                        title: section,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNav, {
                            children: items.sort((a, b)=>{
                                const aIntro = isIntroduction(a);
                                const bIntro = isIntroduction(b);
                                if (aIntro && !bIntro) return -1;
                                if (!aIntro && bIntro) return 1;
                                return title(a).localeCompare(title(b));
                            }).filter((page)=>!page.exports?.isSubpage).map((page)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavItem, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavLink, {
                                        href: page.url,
                                        page: page,
                                        isSelected: page.url === displayUrl,
                                        children: title(page)
                                    })
                                }, page.url))
                        })
                    }, section))
            });
            else nav = /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNav, {
                children: pages.sort((a, b)=>{
                    let aIntro = isIntroduction(a);
                    let bIntro = isIntroduction(b);
                    if (aIntro && !bIntro) return -1;
                    if (!aIntro && bIntro) return 1;
                    return title(a).localeCompare(title(b));
                }).filter((page)=>!page.exports?.isSubpage).map((page)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavItem, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavLink, {
                            href: page.url,
                            isSelected: page.url === currentPage.url,
                            children: title(page)
                        })
                    }, page.url))
            });
            if (name === 'Overview' && Array.isArray(pages) || currentLibrary === 'internationalized' && Array.isArray(pages)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " S7Plwm12",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavSection, {
                    title: name,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNav, {
                        children: pages.sort((a, b)=>{
                            const aIntro = isIntroduction(a);
                            const bIntro = isIntroduction(b);
                            if (aIntro && !bIntro) return -1;
                            if (!aIntro && bIntro) return 1;
                            return title(a).localeCompare(title(b));
                        }).filter((page)=>!page.exports?.isSubpage).map((page)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavItem, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavLink, {
                                    href: page.url,
                                    isSelected: page.url === currentPage.url,
                                    children: title(page)
                                })
                            }, page.url))
                    })
                })
            }, name);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Disclosure), {
                id: name,
                isQuiet: true,
                density: "spacious",
                defaultExpanded: name === 'Components',
                styles: " NJoCOpe12",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.DisclosureTitle), {
                        children: name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.DisclosurePanel), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: " S6vyWPe12",
                            children: nav
                        })
                    })
                ]
            }, name);
        })
    });
}
function title(page) {
    return page.exports?.title ?? page.tableOfContents?.[0]?.title ?? page.name;
}
function isIntroduction(page) {
    let navTitle = page.exports?.navigationTitle;
    if (typeof navTitle === 'string' && /introduction|home/i.test(navTitle)) return true;
    let t = title(page);
    return typeof t === 'string' && /introduction|home/i.test(t);
}
function SideNavSection({ title, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        className: " GC12",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-b12 vx12 xb12 _xa12 _Fd12 _FezxGHba12 _FnuYUweb12 pn12 Mi12 Se12 Re12 sd12 eb12",
                children: title
            }),
            children
        ]
    });
}
const SideNavContext = /*#__PURE__*/ (0, _react.createContext)('');
function usePendingPage(pages) {
    const snapshot = (0, _react.useSyncExternalStore)((0, _navigationSuspense.subscribe), (0, _navigationSuspense.getSnapshot), (0, _navigationSuspense.getSnapshot));
    return snapshot.pathname ? (0, _navigationSuspense.getPageFromPathname)(pages, snapshot.pathname) : null;
}
function SideNav({ children, isNested = false }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' _Gc12';
            if (props.isNested) rules += ' Tt12';
            else rules += ' Td12';
            rules += ' Qd12';
            rules += ' Sd12';
            rules += ' S6XE6sdf12';
            rules += ' Rd12';
            rules += ' Jy12';
            rules += ' Gy12';
            rules += ' Iy12';
            rules += ' Hy12';
            rules += ' sd12';
            rules += ' _ta12';
            rules += ' Ue12';
            rules += ' qe12';
            rules += ' Za12';
            rules += ' _oa12';
            return rules;
        }({
            isNested
        }),
        children: children
    });
}
function SideNavItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        children: props.children
    });
}
function SideNavLink(props1) {
    let linkRef = (0, _react.useRef)(null);
    let selected = (0, _react.useContext)(SideNavContext);
    let { ...linkProps } = props1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...linkProps,
        ref: linkRef,
        "aria-current": props1.isSelected || selected === props1.href ? 'page' : undefined,
        style: (0, _s2.pressScale)(linkRef),
        className: function anonymous(props) {
            let rules = " ";
            if (props.isFocusVisible) rules += ' _Lf12';
            else rules += ' _Le12';
            rules += ' Oh12';
            rules += ' _Mc12';
            rules += ' _Kd12';
            rules += ' Mi12';
            rules += ' _oa12';
            rules += ' Sp12';
            rules += ' Rp12';
            rules += ' sd12';
            rules += ' eb12';
            rules += ' UssxDec12';
            rules += ' qssxDec12';
            rules += ' uk12';
            rules += ' uch12';
            rules += ' udi12';
            rules += ' uea12';
            rules += ' ugb12';
            rules += ' uhd12';
            rules += ' uje12';
            rules += ' u2NhKxcl12';
            rules += ' uic12';
            rules += ' -_6BNtrc-c12';
            rules += ' vx12';
            if (props.isCurrent) {
                rules += ' xd12';
                rules += ' _xa12';
                rules += ' xX0cczbc12';
                rules += ' _xX0cczba12';
            } else {
                rules += ' xb12';
                rules += ' _xa12';
            }
            rules += ' _Fd12';
            rules += ' _FezxGHba12';
            rules += ' _FnuYUweb12';
            rules += ' pt12';
            rules += ' _Xa12';
            rules += ' ob12';
            rules += ' nb12';
            rules += ' kb12';
            rules += ' jb12';
            rules += ' Yd12';
            rules += ' Xb12';
            rules += ' _2b12';
            return rules;
        },
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' Zf12';
                            rules += ' FObNfn12';
                            rules += ' og12';
                            rules += ' ng12';
                            rules += ' kg12';
                            rules += ' jg12';
                            rules += ' Yd12';
                            rules += ' Xb12';
                            rules += ' _2b12';
                            if (props.isCurrent) rules += ' g012';
                            else if (props.isHovered) rules += ' gw12';
                            else rules += ' g912';
                            return rules;
                        }(renderProps)
                    }),
                    props1.children
                ]
            })
    });
}
function useCurrentSection() {
    let [selected, setSelected] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        let elements = Array.from(document.querySelectorAll('article :is(h2,h3,h4,h5)'));
        let visible = new Set();
        let observer = new IntersectionObserver((entries)=>{
            for (let entry of entries){
                if (entry.isIntersecting) visible.add(entry.target);
                else visible.delete(entry.target);
                let firstVisible = elements.find((e)=>visible.has(e));
                if (firstVisible) setSelected('#' + firstVisible.id);
            }
        }, {
            rootMargin: '0px 0px -50% 0px'
        });
        for (let element of elements)observer.observe(element);
        return ()=>observer.disconnect();
    }, []);
    return selected;
}
function OnPageNav({ children }) {
    let selected = useCurrentSection();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavContext.Provider, {
        value: selected,
        children: children
    });
}
function MobileOnPageNav({ children, currentPage }) {
    let [selected, setSelected] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        let elements = Array.from(document.querySelectorAll('article > :is(h1,h2,h3,h4,h5)'));
        elements.reverse();
        let visible = new Set();
        let observer = new IntersectionObserver((entries)=>{
            for (let entry of entries)if (entry.isIntersecting) visible.add(entry.target);
            else visible.delete(entry.target);
            let lastVisible = elements.find((e)=>visible.has(e));
            if (lastVisible) setSelected('#' + lastVisible.id);
            else setSelected('#' + elements.at(-1).id);
        }, {
            rootMargin: '9999999px 0px -100% 0px',
            // @ts-ignore
            scrollMargin: '0px 0px 62px 0px',
            threshold: 0.5
        });
        for (let element of elements)observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        currentPage
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Picker), {
        "aria-label": "Table of contents",
        value: selected,
        isQuiet: true,
        size: "L",
        children: children
    });
}

},{"0":"kr3Zp","1":"j0bDS","2":"em0fw","3":"dR1mU","4":"2SxIO","5":"aSDjJ","6":"ftVxs","7":"acWN3","8":"7oqAb","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["Disclosure","jAvgn"],["DisclosurePanel","jAvgn"],["DisclosureTitle","jAvgn"],["Picker","akpch"],["pressScale","8Ufux"]],"./library":"a5H2j","./NavigationSuspense":"4mbjg","react-aria-components":"fOCdV","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2Is6Z":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"6vHrA"}],"6vHrA":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"jAvgn":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisclosureContext", ()=>DisclosureContext);
parcelHelpers.export(exports, "Disclosure", ()=>Disclosure);
parcelHelpers.export(exports, "DisclosureHeader", ()=>DisclosureHeader);
parcelHelpers.export(exports, "DisclosureTitle", ()=>DisclosureTitle);
parcelHelpers.export(exports, "DisclosurePanel", ()=>DisclosurePanel);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _reactAriaComponents = require("react-aria-components");
var _centerBaseline = require("./CenterBaseline");
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const DisclosureContext = /*#__PURE__*/ (0, _react.createContext)(null);
const disclosure = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    rules += ' po12';
    if (props.isQuiet) rules += ' _ka12';
    else rules += ' _kb12';
    if (props.isInGroup) {
        rules += ' ha12';
        if (props.isQuiet) rules += ' hka12';
        else rules += ' hkb12';
    } else if (props.isQuiet) rules += ' ha12';
    else rules += ' hb12';
    rules += ' ma12';
    rules += ' la12';
    rules += ' _jf12';
    rules += ' ir12';
    if (!minWidth) rules += ' Ng12';
    return rules;
};
const Disclosure = /*#__PURE__*/ (0, _react.forwardRef)(function Disclosure(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, DisclosureContext);
    let { size = 'M', density = 'regular', isQuiet, UNSAFE_style, UNSAFE_className = '' } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isInGroup = (0, _react.useContext)(DisclosureContext) !== null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                DisclosureContext,
                {
                    size,
                    isQuiet,
                    density
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Disclosure), {
            ...props,
            ref: domRef,
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + disclosure({
                isQuiet,
                isInGroup
            }, props.styles),
            children: props.children
        })
    });
});
const headingStyle = " Jy12 Gy12 Iy12 Hy12 _ub12 sd12 _vb12 Na12";
const buttonStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kb12';
    rules += ' uk12';
    rules += ' uch12';
    rules += ' udi12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-f12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    rules += ' xd12';
    rules += ' _xa12';
    rules += ' xX0cczbc12';
    rules += ' _xX0cczba12';
    rules += ' _Fd12';
    rules += ' _FezxGHba12';
    rules += ' _FnuYUweb12';
    if (props.isDisabled) rules += ' pp12';
    else {
        if (props.isPressed) rules += ' po12';
        else if (props.isFocusVisible) rules += ' po12';
        else if (props.isHovered) rules += ' po12';
        else rules += ' pt12';
    }
    rules += ' sd12';
    rules += ' _ub12';
    rules += ' ea12';
    rules += ' S6FcKR12';
    rules += ' R6FcKR12';
    rules += ' Tu7Fubd12';
    rules += ' Qu7Fubd12';
    rules += ' U6FcKR12';
    rules += ' q6FcKR12';
    rules += ' MAyFGYc12';
    rules += ' Za12';
    if (props.isPressed) rules += ' gnSjEFb12';
    else if (props.isHovered) rules += ' gabY4te12';
    else if (props.isFocusVisible) rules += ' gabY4te12';
    else rules += ' g912';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' _kJ8iPYd12';
    rules += ' hXMFGYc12';
    rules += ' ma12';
    rules += ' la12';
    if (props.isQuiet) rules += ' ob12';
    else if (props.isFocusVisible) rules += ' ob12';
    else rules += ' od12';
    if (props.isQuiet) rules += ' nb12';
    else if (props.isFocusVisible) rules += ' nb12';
    else rules += ' nd12';
    if (props.isQuiet) rules += ' kb12';
    else if (props.isFocusVisible) rules += ' kb12';
    else rules += ' kd12';
    if (props.isQuiet) rules += ' jb12';
    else if (props.isFocusVisible) rules += ' jb12';
    else rules += ' jd12';
    rules += ' _Wd12';
    rules += ' __ca12';
    if (props.size === "XL") {
        if (props.density === "spacious") rules += ' -M_-Mj12';
        else if (props.density === "regular") rules += ' -M_-Mk12';
        else if (props.density === "compact") rules += ' -M_-Mh12';
    } else if (props.size === "L") {
        if (props.density === "spacious") rules += ' -M_-Mk12';
        else if (props.density === "regular") rules += ' -M_-Mh12';
        else if (props.density === "compact") rules += ' -M_-Mi12';
    } else if (props.size === "M") {
        if (props.density === "spacious") rules += ' -M_-Mh12';
        else if (props.density === "regular") rules += ' -M_-Mi12';
        else if (props.density === "compact") rules += ' -M_-Mg12';
    } else if (props.size === "S") {
        if (props.density === "spacious") rules += ' -M_-Mi12';
        else if (props.density === "regular") rules += ' -M_-Mg12';
        else if (props.density === "compact") rules += ' -M_-Me12';
    }
    rules += ' -_k_-_ka12';
    rules += ' -h_-ha12';
    return rules;
};
const chevronStyles = function anonymous(props) {
    let rules = " ";
    if (props.isExpanded) rules += ' _Sd12';
    else if (props.isRTL) rules += ' _Sc12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' -_8sjo0b-t5ZbAob12';
    rules += ' _va12';
    return rules;
};
const InternalDisclosureHeader = /*#__PURE__*/ (0, _react.createContext)(null);
function DisclosureHeaderWithForwardRef(props, ref) {
    let { UNSAFE_className, UNSAFE_style, children } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { size, isQuiet, density } = (0, _reactAriaComponents.useSlottedContext)(DisclosureContext);
    // Shift button size down by 2 for compact density, 1 for regular/spacious to ensure there is space between the top and bottom of the action button and container
    let newSize = size;
    const sizes = [
        'XS',
        'S',
        'M',
        'L',
        'XL'
    ];
    const currentIndex = sizes.indexOf(size ?? 'M');
    const shift = density === 'compact' ? 2 : 1;
    newSize = sizes[Math.max(0, currentIndex - shift)];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _actionButton.ActionButtonContext),
                {
                    size: newSize,
                    isQuiet
                }
            ],
            [
                InternalDisclosureHeader,
                {}
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + " sd12 eb12 Ub12 qb12",
            ref: domRef,
            children: children
        })
    });
}
const DisclosureHeader = /*#__PURE__*/ (0, _react.forwardRef)(DisclosureHeaderWithForwardRef);
const DisclosureTitle = /*#__PURE__*/ (0, _react.forwardRef)(function DisclosureTitle(props, ref) {
    let { level = 3, UNSAFE_style, UNSAFE_className = '', ...otherProps } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    const domProps = (0, _utils.filterDOMProps)(otherProps);
    let { direction } = (0, _reactAriaComponents.useLocale)();
    let { isExpanded } = (0, _react.useContext)((0, _reactAriaComponents.DisclosureStateContext));
    let { size, density, isQuiet } = (0, _reactAriaComponents.useSlottedContext)(DisclosureContext);
    let isRTL = direction === 'rtl';
    let buttonTrigger = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
        ...domProps,
        level: level,
        ref: domRef,
        style: UNSAFE_style,
        className: (UNSAFE_className ?? '') + headingStyle,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
            className: (renderProps)=>buttonStyles({
                    ...renderProps,
                    size,
                    density,
                    isQuiet
                }),
            slot: "trigger",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
                        size: size,
                        className: chevronStyles({
                            isExpanded,
                            isRTL
                        }),
                        "aria-hidden": "true"
                    })
                }),
                props.children
            ]
        })
    });
    let ctx = (0, _react.useContext)(InternalDisclosureHeader);
    if (ctx) return buttonTrigger;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DisclosureHeader, {
        children: buttonTrigger
    });
});
const panelStyles = " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-d12 vx12 xb12 _xa12 _Fb12 _FnuYUwec12 pt12 FfwmW1d12 _Nb12 Pb12 Ysgyfc12 Ydklsgce12 Xb12 Xdklsgcb12 _2b12 _2dklsgcb12";
const panelInner = function anonymous(props) {
    let rules = " ";
    rules += ' Tt12';
    rules += ' Qf12';
    if (props.size === "XL") rules += ' Sz5EUbe12';
    else if (props.size === "L") rules += ' Se12';
    else if (props.size === "M") rules += ' SLabwmd12';
    else if (props.size === "S") rules += ' St12';
    if (props.size === "XL") rules += ' Rz5EUbe12';
    else if (props.size === "L") rules += ' Re12';
    else if (props.size === "M") rules += ' RLabwmd12';
    else if (props.size === "S") rules += ' Rt12';
    return rules;
};
const DisclosurePanel = /*#__PURE__*/ (0, _react.forwardRef)(function DisclosurePanel(props, ref) {
    let { UNSAFE_style, UNSAFE_className = '', ...otherProps } = props;
    const domProps = (0, _utils.filterDOMProps)(otherProps);
    let { size } = (0, _reactAriaComponents.useSlottedContext)(DisclosureContext);
    let panelRef = (0, _utils1.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DisclosurePanel), {
        ...domProps,
        ref: panelRef,
        style: UNSAFE_style,
        className: (UNSAFE_className ?? '') + panelStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: panelInner({
                size
            }),
            children: props.children
        })
    });
});

},{"0":"6bQOr","1":"9pGVA","2":"6TvtT","3":"c9UcY","4":"9hOLE","5":"gxTTv","6":"kAlQQ","react/jsx-runtime":"2Is6Z","./ActionButton":"lNDRs","react-aria-components":[["Button","9G5XO"],["Disclosure","hRrWd"],["DisclosurePanel","hRrWd"],["DisclosureStateContext","hRrWd"],["Heading","2f4nH"],["Provider","bA6Cz"],["useSlottedContext","bA6Cz"],["useLocale","4k4z8"]],"./CenterBaseline":"1vpL9","../ui-icons/Chevron":"1904U","@react-aria/utils":"3upVm","react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6bQOr":[function() {},{}],"9pGVA":[function() {},{}],"6TvtT":[function() {},{}],"c9UcY":[function() {},{}],"9hOLE":[function() {},{}],"gxTTv":[function() {},{}],"kAlQQ":[function() {},{}],"a1TxN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"4tF2f"}],"4tF2f":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.1.0";

},{}],"3OmcS":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"kr3Zp":[function() {},{}],"j0bDS":[function() {},{}],"em0fw":[function() {},{}],"dR1mU":[function() {},{}],"2SxIO":[function() {},{}],"aSDjJ":[function() {},{}],"ftVxs":[function() {},{}],"acWN3":[function() {},{}],"7oqAb":[function() {},{}],"8j4BZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OptimisticToc", ()=>OptimisticToc);
parcelHelpers.export(exports, "OptimisticMobileToc", ()=>OptimisticMobileToc);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _markdownMenu = require("./MarkdownMenu");
var _nav = require("./Nav");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _scrollableToc = require("./ScrollableToc");
'use client';
function anchorId(children) {
    return children.replace(/\s/g, '-').replace(/[^a-zA-Z0-9-_]/g, '').toLowerCase();
}
function Toc({ toc, isNested = false }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.OnPageNav), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.SideNav), {
            isNested: isNested,
            children: toc.map((c, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _nav.SideNavItem), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.SideNavLink), {
                            href: '#' + anchorId(c.title),
                            children: c.title
                        }),
                        c.children.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Toc, {
                            toc: c.children,
                            isNested: true
                        })
                    ]
                }, i))
        })
    });
}
function renderMobileToc(toc, seen = new Map()) {
    return toc.map((c)=>{
        let href = c.level === 1 ? '#top' : '#' + anchorId(c.title);
        if (seen.has(href)) {
            seen.set(href, seen.get(href) + 1);
            href += '-' + seen.get(href);
        } else seen.set(href, 1);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                    id: href,
                    href: href,
                    children: c.title
                }),
                c.children.length > 0 && renderMobileToc(c.children, seen)
            ]
        }, href);
    });
}
function OptimisticToc({ currentPage, pages }) {
    let pendingPage = (0, _nav.usePendingPage)(pages);
    let displayPage = pendingPage ?? currentPage;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-d12 vx12 xd12 _xa12 xX0cczbc12 _xX0cczba12 xfd12 _xfa12 xfX0cczbc12 _xfX0cczba12 _Fd12 _FezxGHba12 _FnuYUweb12 po12 Mi12 Se12 Re12 sd12 eb12 Gs12 _va12",
                children: "On this page"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scrollableToc.ScrollableToc), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Toc, {
                    toc: displayPage.tableOfContents?.[0]?.children ?? []
                }, displayPage.url)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " _va12",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Divider), {
                        size: "S",
                        styles: " Jx12 Gx12"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownMenu.MarkdownMenu), {
                        url: currentPage.url
                    })
                ]
            })
        ]
    });
}
function OptimisticMobileToc({ currentPage, pages }) {
    let pendingPage = (0, _nav.usePendingPage)(pages);
    let displayPage = pendingPage ?? currentPage;
    if ((displayPage.tableOfContents?.[0]?.children?.length ?? 0) <= 1) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.MobileOnPageNav), {
        currentPage: currentPage,
        children: renderMobileToc(displayPage.tableOfContents ?? [])
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["Divider","kGk2u"],["PickerItem","akpch"]],"./MarkdownMenu":"8BIYE","./Nav":"iFN5Z","react":"a1TxN","./ScrollableToc":"iKE7T","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4oKuc":[function(require,module,exports,__globalThis) {
var _serverEdge = require("react-server-dom-parcel/server.edge");
exports.__esModule = true;

},{"react-server-dom-parcel/server.edge":"74WJu"}],"74WJu":[function(require,module,exports,__globalThis) {
'use strict';
var s;
s = require("8884f512c685da86");
exports.renderToReadableStream = s.renderToReadableStream;
exports.decodeReply = s.decodeReply;
exports.decodeReplyFromAsyncIterable = s.decodeReplyFromAsyncIterable;
exports.decodeAction = s.decodeAction;
exports.decodeFormState = s.decodeFormState;
exports.createClientReference = s.createClientReference;
exports.registerServerReference = s.registerServerReference;
exports.createTemporaryReferenceSet = s.createTemporaryReferenceSet;
exports.registerServerActions = s.registerServerActions;
exports.loadServerAction = s.loadServerAction;

},{"8884f512c685da86":"iGhi4"}],"iGhi4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-server.edge.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactDOM = require("2381f0f3ff03ff95"), React = require("6db66a729b66b575"), ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule$1(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.postpone");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var LocalPromise = Promise, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    LocalPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
}, currentView = null, writtenBytes = 0;
function writeChunkAndReturn(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = new Uint8Array(2048), writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = currentView.length - writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue(currentView) : (currentView.set(chunk.subarray(0, allowableBytes), writtenBytes), destination.enqueue(currentView), chunk = chunk.subarray(allowableBytes)), currentView = new Uint8Array(2048), writtenBytes = 0);
            currentView.set(chunk, writtenBytes);
            writtenBytes += chunk.byteLength;
        }
    }
    return !0;
}
var textEncoder = new TextEncoder();
function stringToChunk(content) {
    return textEncoder.encode(content);
}
function byteLengthOfChunk(chunk) {
    return chunk.byteLength;
}
function closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var CLIENT_REFERENCE_TAG$1 = Symbol.for("react.client.reference"), SERVER_REFERENCE_TAG = Symbol.for("react.server.reference"), FunctionBind = Function.prototype.bind, ArraySlice = Array.prototype.slice;
function bind() {
    var newFn = FunctionBind.apply(this, arguments);
    if (this.$$typeof === SERVER_REFERENCE_TAG) {
        var args = ArraySlice.call(arguments, 1), $$typeof = {
            value: SERVER_REFERENCE_TAG
        }, $$id = {
            value: this.$$id
        };
        args = {
            value: this.$$bound ? this.$$bound.concat(args) : args
        };
        return Object.defineProperties(newFn, {
            $$typeof: $$typeof,
            $$id: $$id,
            $$bound: args,
            bind: {
                value: bind,
                configurable: !0
            }
        });
    }
    return newFn;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function prefetchDNS(href) {
    if ("string" === typeof href && href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "D|" + href;
            hints.has(key) || (hints.add(key), emitHint(request, "D", href));
        } else previousDispatcher.D(href);
    }
}
function preconnect(href, crossOrigin) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "C|" + (null == crossOrigin ? "null" : crossOrigin) + "|" + href;
            hints.has(key) || (hints.add(key), "string" === typeof crossOrigin ? emitHint(request, "C", [
                href,
                crossOrigin
            ]) : emitHint(request, "C", href));
        } else previousDispatcher.C(href, crossOrigin);
    }
}
function preload(href, as, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "L";
            if ("image" === as && options) {
                var imageSrcSet = options.imageSrcSet, imageSizes = options.imageSizes, uniquePart = "";
                "string" === typeof imageSrcSet && "" !== imageSrcSet ? (uniquePart += "[" + imageSrcSet + "]", "string" === typeof imageSizes && (uniquePart += "[" + imageSizes + "]")) : uniquePart += "[][]" + href;
                key += "[image]" + uniquePart;
            } else key += "[" + as + "]" + href;
            hints.has(key) || (hints.add(key), (options = trimOptions(options)) ? emitHint(request, "L", [
                href,
                as,
                options
            ]) : emitHint(request, "L", [
                href,
                as
            ]));
        } else previousDispatcher.L(href, as, options);
    }
}
function preloadModule(href, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "m|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "m", [
                href,
                options
            ]) : emitHint(request, "m", href);
        }
        previousDispatcher.m(href, options);
    }
}
function preinitStyle(href, precedence, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "S|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "S", [
                href,
                "string" === typeof precedence ? precedence : 0,
                options
            ]) : "string" === typeof precedence ? emitHint(request, "S", [
                href,
                precedence
            ]) : emitHint(request, "S", href);
        }
        previousDispatcher.S(href, precedence, options);
    }
}
function preinitScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "X|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "X", [
                src,
                options
            ]) : emitHint(request, "X", src);
        }
        previousDispatcher.X(src, options);
    }
}
function preinitModuleScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "M|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "M", [
                src,
                options
            ]) : emitHint(request, "M", src);
        }
        previousDispatcher.M(src, options);
    }
}
function trimOptions(options) {
    if (null == options) return null;
    var hasProperties = !1, trimmed = {}, key;
    for(key in options)null != options[key] && (hasProperties = !0, trimmed[key] = options[key]);
    return hasProperties ? trimmed : null;
}
var supportsRequestStorage = "function" === typeof AsyncLocalStorage, requestStorage = supportsRequestStorage ? new AsyncLocalStorage() : null, TEMPORARY_REFERENCE_TAG = Symbol.for("react.temporary.reference"), proxyHandlers = {
    get: function(target, name) {
        switch(name){
            case "$$typeof":
                return target.$$typeof;
            case "name":
                return;
            case "displayName":
                return;
            case "defaultProps":
                return;
            case "_debugInfo":
                return;
            case "toJSON":
                return;
            case Symbol.toPrimitive:
                return Object.prototype[Symbol.toPrimitive];
            case Symbol.toStringTag:
                return Object.prototype[Symbol.toStringTag];
            case "Provider":
                throw Error("Cannot render a Client Context Provider on the Server. Instead, you can export a Client Component wrapper that itself renders a Client Context Provider.");
        }
        throw Error("Cannot access " + String(name) + " on the server. You cannot dot into a temporary client reference from a server component. You can only pass the value through to the client.");
    },
    set: function() {
        throw Error("Cannot assign to a temporary client reference from a server module.");
    }
};
function createTemporaryReference(temporaryReferences, id) {
    var reference = Object.defineProperties(function() {
        throw Error("Attempted to call a temporary Client Reference from the server but it is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component.");
    }, {
        $$typeof: {
            value: TEMPORARY_REFERENCE_TAG
        }
    });
    reference = new Proxy(reference, proxyHandlers);
    temporaryReferences.set(reference, id);
    return reference;
}
function noop() {}
var SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`.");
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop, noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then(noop, noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
var currentRequest$1 = null, thenableIndexCounter = 0, thenableState = null;
function getThenableStateAfterSuspending() {
    var state = thenableState || [];
    thenableState = null;
    return state;
}
var HooksDispatcher = {
    readContext: unsupportedContext,
    use: use,
    useCallback: function(callback) {
        return callback;
    },
    useContext: unsupportedContext,
    useEffect: unsupportedHook,
    useImperativeHandle: unsupportedHook,
    useLayoutEffect: unsupportedHook,
    useInsertionEffect: unsupportedHook,
    useMemo: function(nextCreate) {
        return nextCreate();
    },
    useReducer: unsupportedHook,
    useRef: unsupportedHook,
    useState: unsupportedHook,
    useDebugValue: function() {},
    useDeferredValue: unsupportedHook,
    useTransition: unsupportedHook,
    useSyncExternalStore: unsupportedHook,
    useId: useId,
    useHostTransitionStatus: unsupportedHook,
    useFormState: unsupportedHook,
    useActionState: unsupportedHook,
    useOptimistic: unsupportedHook,
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return unsupportedRefresh;
    }
};
function unsupportedHook() {
    throw Error("This Hook is not supported in Server Components.");
}
function unsupportedRefresh() {
    throw Error("Refreshing the cache is not supported in Server Components.");
}
function unsupportedContext() {
    throw Error("Cannot read a Client Context from a Server Component.");
}
function useId() {
    if (null === currentRequest$1) throw Error("useId can only be used while React is rendering");
    var id = currentRequest$1.identifierCount++;
    return "_" + currentRequest$1.identifierPrefix + "S_" + id.toString(32) + "_";
}
function use(usable) {
    if (null !== usable && "object" === typeof usable || "function" === typeof usable) {
        if ("function" === typeof usable.then) {
            var index = thenableIndexCounter;
            thenableIndexCounter += 1;
            null === thenableState && (thenableState = []);
            return trackUsedThenable(thenableState, usable, index);
        }
        usable.$$typeof === REACT_CONTEXT_TYPE && unsupportedContext();
    }
    if (usable.$$typeof === CLIENT_REFERENCE_TAG$1) {
        if (null != usable.value && usable.value.$$typeof === REACT_CONTEXT_TYPE) throw Error("Cannot read a Client Context from a Server Component.");
        throw Error("Cannot use() an already resolved Client Reference.");
    }
    throw Error("An unsupported type was passed to use(): " + String(usable));
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var JSCompiler_inline_result = (JSCompiler_inline_result = resolveRequest()) ? JSCompiler_inline_result.cache : new Map();
        var entry = JSCompiler_inline_result.get(resourceType);
        void 0 === entry && (entry = resourceType(), JSCompiler_inline_result.set(resourceType, entry));
        return entry;
    },
    cacheSignal: function() {
        var request = resolveRequest();
        return request ? request.cacheController.signal : null;
    }
}, ReactSharedInternalsServer = React.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
if (!ReactSharedInternalsServer) throw Error('The "react" package in this environment is not configured correctly. The "react-server" condition must be enabled in any environment that runs React Server Components.');
var isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf;
function objectName(object) {
    object = Object.prototype.toString.call(object);
    return object.slice(8, object.length - 1);
}
function describeValueForErrorMessage(value) {
    switch(typeof value){
        case "string":
            return JSON.stringify(10 >= value.length ? value : value.slice(0, 10) + "...");
        case "object":
            if (isArrayImpl(value)) return "[...]";
            if (null !== value && value.$$typeof === CLIENT_REFERENCE_TAG) return "client";
            value = objectName(value);
            return "Object" === value ? "{...}" : value;
        case "function":
            return value.$$typeof === CLIENT_REFERENCE_TAG ? "client" : (value = value.displayName || value.name) ? "function " + value : "function";
        default:
            return String(value);
    }
}
function describeElementType(type) {
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_FORWARD_REF_TYPE:
            return describeElementType(type.render);
        case REACT_MEMO_TYPE:
            return describeElementType(type.type);
        case REACT_LAZY_TYPE:
            var payload = type._payload;
            type = type._init;
            try {
                return describeElementType(type(payload));
            } catch (x) {}
    }
    return "";
}
var CLIENT_REFERENCE_TAG = Symbol.for("react.client.reference");
function describeObjectForErrorMessage(objectOrArray, expandedName) {
    var objKind = objectName(objectOrArray);
    if ("Object" !== objKind && "Array" !== objKind) return objKind;
    objKind = -1;
    var length = 0;
    if (isArrayImpl(objectOrArray)) {
        var str = "[";
        for(var i = 0; i < objectOrArray.length; i++){
            0 < i && (str += ", ");
            var value = objectOrArray[i];
            value = "object" === typeof value && null !== value ? describeObjectForErrorMessage(value) : describeValueForErrorMessage(value);
            "" + i === expandedName ? (objKind = str.length, length = value.length, str += value) : str = 10 > value.length && 40 > str.length + value.length ? str + value : str + "...";
        }
        str += "]";
    } else if (objectOrArray.$$typeof === REACT_ELEMENT_TYPE) str = "<" + describeElementType(objectOrArray.type) + "/>";
    else {
        if (objectOrArray.$$typeof === CLIENT_REFERENCE_TAG) return "client";
        str = "{";
        i = Object.keys(objectOrArray);
        for(value = 0; value < i.length; value++){
            0 < value && (str += ", ");
            var name = i[value], encodedKey = JSON.stringify(name);
            str += ('"' + name + '"' === encodedKey ? name : encodedKey) + ": ";
            encodedKey = objectOrArray[name];
            encodedKey = "object" === typeof encodedKey && null !== encodedKey ? describeObjectForErrorMessage(encodedKey) : describeValueForErrorMessage(encodedKey);
            name === expandedName ? (objKind = str.length, length = encodedKey.length, str += encodedKey) : str = 10 > encodedKey.length && 40 > str.length + encodedKey.length ? str + encodedKey : str + "...";
        }
        str += "}";
    }
    return void 0 === expandedName ? str : -1 < objKind && 0 < length ? (objectOrArray = " ".repeat(objKind) + "^".repeat(length), "\n  " + str + "\n  " + objectOrArray) : "\n  " + str;
}
var hasOwnProperty = Object.prototype.hasOwnProperty, ObjectPrototype = Object.prototype, stringify = JSON.stringify;
function defaultErrorHandler(error) {
    console.error(error);
}
function RequestInstance(type, model, bundlerConfig, onError, onPostpone, onAllReady, onFatalError, identifierPrefix, temporaryReferences) {
    if (null !== ReactSharedInternalsServer.A && ReactSharedInternalsServer.A !== DefaultAsyncDispatcher) throw Error("Currently React only supports one RSC renderer at a time.");
    ReactSharedInternalsServer.A = DefaultAsyncDispatcher;
    var abortSet = new Set(), pingedTasks = [], hints = new Set();
    this.type = type;
    this.status = 10;
    this.flushScheduled = !1;
    this.destination = this.fatalError = null;
    this.bundlerConfig = bundlerConfig;
    this.cache = new Map();
    this.cacheController = new AbortController();
    this.pendingChunks = this.nextChunkId = 0;
    this.hints = hints;
    this.abortableTasks = abortSet;
    this.pingedTasks = pingedTasks;
    this.completedImportChunks = [];
    this.completedHintChunks = [];
    this.completedRegularChunks = [];
    this.completedErrorChunks = [];
    this.writtenSymbols = new Map();
    this.writtenClientReferences = new Map();
    this.writtenServerReferences = new Map();
    this.writtenObjects = new WeakMap();
    this.temporaryReferences = temporaryReferences;
    this.identifierPrefix = identifierPrefix || "";
    this.identifierCount = 1;
    this.taintCleanupQueue = [];
    this.onError = void 0 === onError ? defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = onAllReady;
    this.onFatalError = onFatalError;
    type = createTask(this, model, null, !1, abortSet);
    pingedTasks.push(type);
}
var currentRequest = null;
function resolveRequest() {
    if (currentRequest) return currentRequest;
    if (supportsRequestStorage) {
        var store = requestStorage.getStore();
        if (store) return store;
    }
    return null;
}
function serializeThenable(request, task, thenable) {
    var newTask = createTask(request, thenable, task.keyPath, task.implicitSlot, request.abortableTasks);
    switch(thenable.status){
        case "fulfilled":
            return newTask.model = thenable.value, pingTask(request, newTask), newTask.id;
        case "rejected":
            return erroredTask(request, newTask, thenable.reason), newTask.id;
        default:
            if (12 === request.status) return request.abortableTasks.delete(newTask), task = request.fatalError, abortTask(newTask), finishAbortedTask(newTask, request, task), newTask.id;
            "string" !== typeof thenable.status && (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            }));
    }
    thenable.then(function(value) {
        newTask.model = value;
        pingTask(request, newTask);
    }, function(reason) {
        0 === newTask.status && (erroredTask(request, newTask, reason), enqueueFlush(request));
    });
    return newTask.id;
}
function serializeReadableStream(request, task, stream) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) streamTask.status = 1, entry = streamTask.id.toString(16) + ":C\n", request.completedRegularChunks.push(stringToChunk(entry)), request.abortableTasks.delete(streamTask), request.cacheController.signal.removeEventListener("abort", abortStream), enqueueFlush(request), callOnAllReadyIfReady(request);
            else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), reader.read().then(progress, error);
            } catch (x$8) {
                error(x$8);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortStream), erroredTask(request, streamTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortStream() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortStream);
            signal = signal.reason;
            erroredTask(request, streamTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var supportsBYOB = stream.supportsBYOB;
    if (void 0 === supportsBYOB) try {
        stream.getReader({
            mode: "byob"
        }).releaseLock(), supportsBYOB = !0;
    } catch (x) {
        supportsBYOB = !1;
    }
    var reader = stream.getReader(), streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (supportsBYOB ? "r" : "R") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortStream);
    reader.read().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function serializeAsyncIterable(request, task, iterable, iterator) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) {
                streamTask.status = 1;
                if (void 0 === entry.value) var endStreamRow = streamTask.id.toString(16) + ":C\n";
                else try {
                    var chunkId = outlineModel(request, entry.value);
                    endStreamRow = streamTask.id.toString(16) + ":C" + stringify(serializeByValueID(chunkId)) + "\n";
                } catch (x) {
                    error(x);
                    return;
                }
                request.completedRegularChunks.push(stringToChunk(endStreamRow));
                request.abortableTasks.delete(streamTask);
                request.cacheController.signal.removeEventListener("abort", abortIterable);
                enqueueFlush(request);
                callOnAllReadyIfReady(request);
            } else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), iterator.next().then(progress, error);
            } catch (x$9) {
                error(x$9);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortIterable), erroredTask(request, streamTask, reason), enqueueFlush(request), "function" === typeof iterator.throw && iterator.throw(reason).then(error, error));
    }
    function abortIterable() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortIterable);
            var reason = signal.reason;
            erroredTask(request, streamTask, signal.reason);
            enqueueFlush(request);
            "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
        }
    }
    iterable = iterable === iterator;
    var streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (iterable ? "x" : "X") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortIterable);
    iterator.next().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function emitHint(request, code, model) {
    model = stringify(model);
    code = stringToChunk(":H" + code + model + "\n");
    request.completedHintChunks.push(code);
    enqueueFlush(request);
}
function readThenable(thenable) {
    if ("fulfilled" === thenable.status) return thenable.value;
    if ("rejected" === thenable.status) throw thenable.reason;
    throw thenable;
}
function createLazyWrapperAroundWakeable(request, task, wakeable) {
    switch(wakeable.status){
        case "fulfilled":
            return wakeable.value;
        case "rejected":
            break;
        default:
            "string" !== typeof wakeable.status && (wakeable.status = "pending", wakeable.then(function(fulfilledValue) {
                "pending" === wakeable.status && (wakeable.status = "fulfilled", wakeable.value = fulfilledValue);
            }, function(error) {
                "pending" === wakeable.status && (wakeable.status = "rejected", wakeable.reason = error);
            }));
    }
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: wakeable,
        _init: readThenable
    };
}
function voidHandler() {}
function processServerComponentReturnValue(request, task, Component, result) {
    if ("object" !== typeof result || null === result || result.$$typeof === CLIENT_REFERENCE_TAG$1) return result;
    if ("function" === typeof result.then) return createLazyWrapperAroundWakeable(request, task, result);
    var iteratorFn = getIteratorFn(result);
    return iteratorFn ? (request = {}, request[Symbol.iterator] = function() {
        return iteratorFn.call(result);
    }, request) : "function" !== typeof result[ASYNC_ITERATOR] || "function" === typeof ReadableStream && result instanceof ReadableStream ? result : (request = {}, request[ASYNC_ITERATOR] = function() {
        return result[ASYNC_ITERATOR]();
    }, request);
}
function renderFunctionComponent(request, task, key, Component, props) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    props = Component(props, void 0);
    if (12 === request.status) throw "object" === typeof props && null !== props && "function" === typeof props.then && props.$$typeof !== CLIENT_REFERENCE_TAG$1 && props.then(voidHandler, voidHandler), null;
    props = processServerComponentReturnValue(request, task, Component, props);
    Component = task.keyPath;
    prevThenableState = task.implicitSlot;
    null !== key ? task.keyPath = null === Component ? key : Component + "," + key : null === Component && (task.implicitSlot = !0);
    request = renderModelDestructive(request, task, emptyRoot, "", props);
    task.keyPath = Component;
    task.implicitSlot = prevThenableState;
    return request;
}
function renderFragment(request, task, children) {
    return null !== task.keyPath ? (request = [
        REACT_ELEMENT_TYPE,
        REACT_FRAGMENT_TYPE,
        task.keyPath,
        {
            children: children
        }
    ], task.implicitSlot ? [
        request
    ] : request) : children;
}
var serializedSize = 0;
function deferTask(request, task) {
    task = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    pingTask(request, task);
    return "$L" + task.id.toString(16);
}
function renderElement(request, task, type, key, ref, props) {
    if (null !== ref && void 0 !== ref) throw Error("Refs cannot be used in Server Components, nor passed to Client Components.");
    if ("function" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1 && type.$$typeof !== TEMPORARY_REFERENCE_TAG) return renderFunctionComponent(request, task, key, type, props);
    if (type === REACT_FRAGMENT_TYPE && null === key) return type = task.implicitSlot, null === task.keyPath && (task.implicitSlot = !0), props = renderModelDestructive(request, task, emptyRoot, "", props.children), task.implicitSlot = type, props;
    if (null != type && "object" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1) switch(type.$$typeof){
        case REACT_LAZY_TYPE:
            var init = type._init;
            type = init(type._payload);
            if (12 === request.status) throw null;
            return renderElement(request, task, type, key, ref, props);
        case REACT_FORWARD_REF_TYPE:
            return renderFunctionComponent(request, task, key, type.render, props);
        case REACT_MEMO_TYPE:
            return renderElement(request, task, type.type, key, ref, props);
    }
    request = key;
    key = task.keyPath;
    null === request ? request = key : null !== key && (request = key + "," + request);
    props = [
        REACT_ELEMENT_TYPE,
        type,
        request,
        props
    ];
    task = task.implicitSlot && null !== request ? [
        props
    ] : props;
    return task;
}
function pingTask(request, task) {
    var pingedTasks = request.pingedTasks;
    pingedTasks.push(task);
    1 === pingedTasks.length && (request.flushScheduled = null !== request.destination, 21 === request.type || 10 === request.status ? scheduleMicrotask(function() {
        return performWork(request);
    }) : setTimeout(function() {
        return performWork(request);
    }, 0));
}
function createTask(request, model, keyPath, implicitSlot, abortSet) {
    request.pendingChunks++;
    var id = request.nextChunkId++;
    "object" !== typeof model || null === model || null !== keyPath || implicitSlot || request.writtenObjects.set(model, serializeByValueID(id));
    var task = {
        id: id,
        status: 0,
        model: model,
        keyPath: keyPath,
        implicitSlot: implicitSlot,
        ping: function() {
            return pingTask(request, task);
        },
        toJSON: function(parentPropertyName, value) {
            serializedSize += parentPropertyName.length;
            var prevKeyPath = task.keyPath, prevImplicitSlot = task.implicitSlot;
            try {
                var JSCompiler_inline_result = renderModelDestructive(request, task, this, parentPropertyName, value);
            } catch (thrownValue) {
                if (parentPropertyName = task.model, parentPropertyName = "object" === typeof parentPropertyName && null !== parentPropertyName && (parentPropertyName.$$typeof === REACT_ELEMENT_TYPE || parentPropertyName.$$typeof === REACT_LAZY_TYPE), 12 === request.status) task.status = 3, prevKeyPath = request.fatalError, JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
                else if (value = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof value && null !== value && "function" === typeof value.then) {
                    JSCompiler_inline_result = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
                    var ping = JSCompiler_inline_result.ping;
                    value.then(ping, ping);
                    JSCompiler_inline_result.thenableState = getThenableStateAfterSuspending();
                    task.keyPath = prevKeyPath;
                    task.implicitSlot = prevImplicitSlot;
                    JSCompiler_inline_result = parentPropertyName ? "$L" + JSCompiler_inline_result.id.toString(16) : serializeByValueID(JSCompiler_inline_result.id);
                } else task.keyPath = prevKeyPath, task.implicitSlot = prevImplicitSlot, request.pendingChunks++, prevKeyPath = request.nextChunkId++, prevImplicitSlot = logRecoverableError(request, value, task), emitErrorChunk(request, prevKeyPath, prevImplicitSlot), JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
            }
            return JSCompiler_inline_result;
        },
        thenableState: null
    };
    abortSet.add(task);
    return task;
}
function serializeByValueID(id) {
    return "$" + id.toString(16);
}
function encodeReferenceChunk(request, id, reference) {
    request = stringify(reference);
    id = id.toString(16) + ":" + request + "\n";
    return stringToChunk(id);
}
function serializeClientReference(request, parent, parentPropertyName, clientReference) {
    var clientReferenceKey = clientReference.$$id + "#" + clientReference.$$name, writtenClientReferences = request.writtenClientReferences, existingId = writtenClientReferences.get(clientReferenceKey);
    if (void 0 !== existingId) return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + existingId.toString(16) : serializeByValueID(existingId);
    try {
        var JSCompiler_inline_result = clientReference.$$importMap ? [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles,
            clientReference.$$importMap
        ] : [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles
        ];
        request.pendingChunks++;
        var importId = request.nextChunkId++, json = stringify(JSCompiler_inline_result), row = importId.toString(16) + ":I" + json + "\n", processedChunk = stringToChunk(row);
        request.completedImportChunks.push(processedChunk);
        writtenClientReferences.set(clientReferenceKey, importId);
        return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + importId.toString(16) : serializeByValueID(importId);
    } catch (x) {
        return request.pendingChunks++, parent = request.nextChunkId++, parentPropertyName = logRecoverableError(request, x, null), emitErrorChunk(request, parent, parentPropertyName), serializeByValueID(parent);
    }
}
function outlineModel(request, value) {
    value = createTask(request, value, null, !1, request.abortableTasks);
    retryTask(request, value);
    return value.id;
}
function serializeTypedArray(request, tag, typedArray) {
    request.pendingChunks++;
    var bufferId = request.nextChunkId++;
    emitTypedArrayChunk(request, bufferId, tag, typedArray, !1);
    return serializeByValueID(bufferId);
}
function serializeBlob(request, blob) {
    function progress(entry) {
        if (0 === newTask.status) {
            if (entry.done) request.cacheController.signal.removeEventListener("abort", abortBlob), pingTask(request, newTask);
            else return model.push(entry.value), reader.read().then(progress).catch(error);
        }
    }
    function error(reason) {
        0 === newTask.status && (request.cacheController.signal.removeEventListener("abort", abortBlob), erroredTask(request, newTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortBlob() {
        if (0 === newTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortBlob);
            signal = signal.reason;
            erroredTask(request, newTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var model = [
        blob.type
    ], newTask = createTask(request, model, null, !1, request.abortableTasks), reader = blob.stream().getReader();
    request.cacheController.signal.addEventListener("abort", abortBlob);
    reader.read().then(progress).catch(error);
    return "$B" + newTask.id.toString(16);
}
var modelRoot = !1;
function renderModelDestructive(request, task, parent, parentPropertyName, value) {
    task.model = value;
    if (value === REACT_ELEMENT_TYPE) return "$";
    if (null === value) return null;
    if ("object" === typeof value) {
        switch(value.$$typeof){
            case REACT_ELEMENT_TYPE:
                var elementReference = null, writtenObjects = request.writtenObjects;
                if (null === task.keyPath && !task.implicitSlot) {
                    var existingReference = writtenObjects.get(value);
                    if (void 0 !== existingReference) {
                        if (modelRoot === value) modelRoot = null;
                        else return existingReference;
                    } else -1 === parentPropertyName.indexOf(":") && (parent = writtenObjects.get(parent), void 0 !== parent && (elementReference = parent + ":" + parentPropertyName, writtenObjects.set(value, elementReference)));
                }
                if (3200 < serializedSize) return deferTask(request, task);
                parentPropertyName = value.props;
                parent = parentPropertyName.ref;
                request = renderElement(request, task, value.type, value.key, void 0 !== parent ? parent : null, parentPropertyName);
                "object" === typeof request && null !== request && null !== elementReference && (writtenObjects.has(request) || writtenObjects.set(request, elementReference));
                return request;
            case REACT_LAZY_TYPE:
                if (3200 < serializedSize) return deferTask(request, task);
                task.thenableState = null;
                parentPropertyName = value._init;
                value = parentPropertyName(value._payload);
                if (12 === request.status) throw null;
                return renderModelDestructive(request, task, emptyRoot, "", value);
            case REACT_LEGACY_ELEMENT_TYPE:
                throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        }
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (void 0 !== request.temporaryReferences && (elementReference = request.temporaryReferences.get(value), void 0 !== elementReference)) return "$T" + elementReference;
        elementReference = request.writtenObjects;
        writtenObjects = elementReference.get(value);
        if ("function" === typeof value.then) {
            if (void 0 !== writtenObjects) {
                if (null !== task.keyPath || task.implicitSlot) return "$@" + serializeThenable(request, task, value).toString(16);
                if (modelRoot === value) modelRoot = null;
                else return writtenObjects;
            }
            request = "$@" + serializeThenable(request, task, value).toString(16);
            elementReference.set(value, request);
            return request;
        }
        if (void 0 !== writtenObjects) {
            if (modelRoot === value) {
                if (writtenObjects !== serializeByValueID(task.id)) return writtenObjects;
                modelRoot = null;
            } else return writtenObjects;
        } else if (-1 === parentPropertyName.indexOf(":") && (writtenObjects = elementReference.get(parent), void 0 !== writtenObjects)) {
            existingReference = parentPropertyName;
            if (isArrayImpl(parent) && parent[0] === REACT_ELEMENT_TYPE) switch(parentPropertyName){
                case "1":
                    existingReference = "type";
                    break;
                case "2":
                    existingReference = "key";
                    break;
                case "3":
                    existingReference = "props";
                    break;
                case "4":
                    existingReference = "_owner";
            }
            elementReference.set(value, writtenObjects + ":" + existingReference);
        }
        if (isArrayImpl(value)) return renderFragment(request, task, value);
        if (value instanceof Map) return value = Array.from(value), "$Q" + outlineModel(request, value).toString(16);
        if (value instanceof Set) return value = Array.from(value), "$W" + outlineModel(request, value).toString(16);
        if ("function" === typeof FormData && value instanceof FormData) return value = Array.from(value.entries()), "$K" + outlineModel(request, value).toString(16);
        if (value instanceof Error) return "$Z";
        if (value instanceof ArrayBuffer) return serializeTypedArray(request, "A", new Uint8Array(value));
        if (value instanceof Int8Array) return serializeTypedArray(request, "O", value);
        if (value instanceof Uint8Array) return serializeTypedArray(request, "o", value);
        if (value instanceof Uint8ClampedArray) return serializeTypedArray(request, "U", value);
        if (value instanceof Int16Array) return serializeTypedArray(request, "S", value);
        if (value instanceof Uint16Array) return serializeTypedArray(request, "s", value);
        if (value instanceof Int32Array) return serializeTypedArray(request, "L", value);
        if (value instanceof Uint32Array) return serializeTypedArray(request, "l", value);
        if (value instanceof Float32Array) return serializeTypedArray(request, "G", value);
        if (value instanceof Float64Array) return serializeTypedArray(request, "g", value);
        if (value instanceof BigInt64Array) return serializeTypedArray(request, "M", value);
        if (value instanceof BigUint64Array) return serializeTypedArray(request, "m", value);
        if (value instanceof DataView) return serializeTypedArray(request, "V", value);
        if ("function" === typeof Blob && value instanceof Blob) return serializeBlob(request, value);
        if (elementReference = getIteratorFn(value)) return parentPropertyName = elementReference.call(value), parentPropertyName === value ? "$i" + outlineModel(request, Array.from(parentPropertyName)).toString(16) : renderFragment(request, task, Array.from(parentPropertyName));
        if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(request, task, value);
        elementReference = value[ASYNC_ITERATOR];
        if ("function" === typeof elementReference) return null !== task.keyPath ? (request = [
            REACT_ELEMENT_TYPE,
            REACT_FRAGMENT_TYPE,
            task.keyPath,
            {
                children: value
            }
        ], request = task.implicitSlot ? [
            request
        ] : request) : (parentPropertyName = elementReference.call(value), request = serializeAsyncIterable(request, task, value, parentPropertyName)), request;
        if (value instanceof Date) return "$D" + value.toJSON();
        request = getPrototypeOf(value);
        if (request !== ObjectPrototype && (null === request || null !== getPrototypeOf(request))) throw Error("Only plain objects, and a few built-ins, can be passed to Client Components from Server Components. Classes or null prototypes are not supported." + describeObjectForErrorMessage(parent, parentPropertyName));
        return value;
    }
    if ("string" === typeof value) {
        serializedSize += value.length;
        if ("Z" === value[value.length - 1] && parent[parentPropertyName] instanceof Date) return "$D" + value;
        if (1024 <= value.length && null !== byteLengthOfChunk) return request.pendingChunks++, task = request.nextChunkId++, emitTextChunk(request, task, value, !1), serializeByValueID(task);
        request = "$" === value[0] ? "$" + value : value;
        return request;
    }
    if ("boolean" === typeof value) return value;
    if ("number" === typeof value) return Number.isFinite(value) ? 0 === value && -Infinity === 1 / value ? "$-0" : value : Infinity === value ? "$Infinity" : -Infinity === value ? "$-Infinity" : "$NaN";
    if ("undefined" === typeof value) return "$undefined";
    if ("function" === typeof value) {
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (value.$$typeof === SERVER_REFERENCE_TAG) return task = request.writtenServerReferences, parentPropertyName = task.get(value), void 0 !== parentPropertyName ? request = "$F" + parentPropertyName.toString(16) : (parentPropertyName = value.$$bound, parentPropertyName = null === parentPropertyName ? null : Promise.resolve(parentPropertyName), request = outlineModel(request, {
            id: value.$$id,
            bound: parentPropertyName
        }), task.set(value, request), request = "$F" + request.toString(16)), request;
        if (void 0 !== request.temporaryReferences && (request = request.temporaryReferences.get(value), void 0 !== request)) return "$T" + request;
        if (value.$$typeof === TEMPORARY_REFERENCE_TAG) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
        if (/^on[A-Z]/.test(parentPropertyName)) throw Error("Event handlers cannot be passed to Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName) + "\nIf you need interactivity, consider converting part of this to a Client Component.");
        throw Error('Functions cannot be passed directly to Client Components unless you explicitly expose it by marking it with "use server". Or maybe you meant to call this function rather than return it.' + describeObjectForErrorMessage(parent, parentPropertyName));
    }
    if ("symbol" === typeof value) {
        task = request.writtenSymbols;
        elementReference = task.get(value);
        if (void 0 !== elementReference) return serializeByValueID(elementReference);
        elementReference = value.description;
        if (Symbol.for(elementReference) !== value) throw Error("Only global symbols received from Symbol.for(...) can be passed to Client Components. The symbol Symbol.for(" + (value.description + ") cannot be found among global symbols.") + describeObjectForErrorMessage(parent, parentPropertyName));
        request.pendingChunks++;
        parentPropertyName = request.nextChunkId++;
        parent = encodeReferenceChunk(request, parentPropertyName, "$S" + elementReference);
        request.completedImportChunks.push(parent);
        task.set(value, parentPropertyName);
        return serializeByValueID(parentPropertyName);
    }
    if ("bigint" === typeof value) return "$n" + value.toString(10);
    throw Error("Type " + typeof value + " is not supported in Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName));
}
function logRecoverableError(request, error) {
    var prevRequest = currentRequest;
    currentRequest = null;
    try {
        var onError = request.onError;
        var errorDigest = supportsRequestStorage ? requestStorage.run(void 0, onError, error) : onError(error);
    } finally{
        currentRequest = prevRequest;
    }
    if (null != errorDigest && "string" !== typeof errorDigest) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
    return errorDigest || "";
}
function fatalError(request, error) {
    var onFatalError = request.onFatalError;
    onFatalError(error);
    null !== request.destination ? (request.status = 14, closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
    request.cacheController.abort(Error("The render was aborted due to a fatal error.", {
        cause: error
    }));
}
function emitErrorChunk(request, id, digest) {
    digest = {
        digest: digest
    };
    id = id.toString(16) + ":E" + stringify(digest) + "\n";
    id = stringToChunk(id);
    request.completedErrorChunks.push(id);
}
function emitModelChunk(request, id, json) {
    id = id.toString(16) + ":" + json + "\n";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id);
}
function emitTypedArrayChunk(request, id, tag, typedArray, debug) {
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    debug = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    typedArray = 2048 < typedArray.byteLength ? debug.slice() : debug;
    debug = typedArray.byteLength;
    id = id.toString(16) + ":" + tag + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, typedArray);
}
function emitTextChunk(request, id, text, debug) {
    if (null === byteLengthOfChunk) throw Error("Existence of byteLengthOfChunk should have already been checked. This is a bug in React.");
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    text = stringToChunk(text);
    debug = text.byteLength;
    id = id.toString(16) + ":T" + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, text);
}
function emitChunk(request, task, value) {
    var id = task.id;
    "string" === typeof value && null !== byteLengthOfChunk ? emitTextChunk(request, id, value, !1) : value instanceof ArrayBuffer ? emitTypedArrayChunk(request, id, "A", new Uint8Array(value), !1) : value instanceof Int8Array ? emitTypedArrayChunk(request, id, "O", value, !1) : value instanceof Uint8Array ? emitTypedArrayChunk(request, id, "o", value, !1) : value instanceof Uint8ClampedArray ? emitTypedArrayChunk(request, id, "U", value, !1) : value instanceof Int16Array ? emitTypedArrayChunk(request, id, "S", value, !1) : value instanceof Uint16Array ? emitTypedArrayChunk(request, id, "s", value, !1) : value instanceof Int32Array ? emitTypedArrayChunk(request, id, "L", value, !1) : value instanceof Uint32Array ? emitTypedArrayChunk(request, id, "l", value, !1) : value instanceof Float32Array ? emitTypedArrayChunk(request, id, "G", value, !1) : value instanceof Float64Array ? emitTypedArrayChunk(request, id, "g", value, !1) : value instanceof BigInt64Array ? emitTypedArrayChunk(request, id, "M", value, !1) : value instanceof BigUint64Array ? emitTypedArrayChunk(request, id, "m", value, !1) : value instanceof DataView ? emitTypedArrayChunk(request, id, "V", value, !1) : (value = stringify(value, task.toJSON), emitModelChunk(request, task.id, value));
}
function erroredTask(request, task, error) {
    task.status = 4;
    error = logRecoverableError(request, error, task);
    emitErrorChunk(request, task.id, error);
    request.abortableTasks.delete(task);
    callOnAllReadyIfReady(request);
}
var emptyRoot = {};
function retryTask(request, task) {
    if (0 === task.status) {
        task.status = 5;
        var parentSerializedSize = serializedSize;
        try {
            modelRoot = task.model;
            var resolvedModel = renderModelDestructive(request, task, emptyRoot, "", task.model);
            modelRoot = resolvedModel;
            task.keyPath = null;
            task.implicitSlot = !1;
            if ("object" === typeof resolvedModel && null !== resolvedModel) request.writtenObjects.set(resolvedModel, serializeByValueID(task.id)), emitChunk(request, task, resolvedModel);
            else {
                var json = stringify(resolvedModel);
                emitModelChunk(request, task.id, json);
            }
            task.status = 1;
            request.abortableTasks.delete(task);
            callOnAllReadyIfReady(request);
        } catch (thrownValue) {
            if (12 === request.status) {
                request.abortableTasks.delete(task);
                task.status = 0;
                var errorId = request.fatalError;
                abortTask(task);
                finishAbortedTask(task, request, errorId);
            } else {
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                    task.status = 0;
                    task.thenableState = getThenableStateAfterSuspending();
                    var ping = task.ping;
                    x.then(ping, ping);
                } else erroredTask(request, task, x);
            }
        } finally{
            serializedSize = parentSerializedSize;
        }
    }
}
function tryStreamTask(request, task) {
    var parentSerializedSize = serializedSize;
    try {
        emitChunk(request, task, task.model);
    } finally{
        serializedSize = parentSerializedSize;
    }
}
function performWork(request) {
    var prevDispatcher = ReactSharedInternalsServer.H;
    ReactSharedInternalsServer.H = HooksDispatcher;
    var prevRequest = currentRequest;
    currentRequest$1 = currentRequest = request;
    try {
        var pingedTasks = request.pingedTasks;
        request.pingedTasks = [];
        for(var i = 0; i < pingedTasks.length; i++)retryTask(request, pingedTasks[i]);
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    } finally{
        ReactSharedInternalsServer.H = prevDispatcher, currentRequest$1 = null, currentRequest = prevRequest;
    }
}
function abortTask(task) {
    0 === task.status && (task.status = 3);
}
function finishAbortedTask(task, request, errorId) {
    3 === task.status && (errorId = serializeByValueID(errorId), task = encodeReferenceChunk(request, task.id, errorId), request.completedErrorChunks.push(task));
}
function flushCompletedChunks(request) {
    var destination = request.destination;
    if (null !== destination) {
        currentView = new Uint8Array(2048);
        writtenBytes = 0;
        try {
            for(var importsChunks = request.completedImportChunks, i = 0; i < importsChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, importsChunks[i]);
            importsChunks.splice(0, i);
            var hintChunks = request.completedHintChunks;
            for(i = 0; i < hintChunks.length; i++)writeChunkAndReturn(destination, hintChunks[i]);
            hintChunks.splice(0, i);
            var regularChunks = request.completedRegularChunks;
            for(i = 0; i < regularChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, regularChunks[i]);
            regularChunks.splice(0, i);
            var errorChunks = request.completedErrorChunks;
            for(i = 0; i < errorChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, errorChunks[i]);
            errorChunks.splice(0, i);
        } finally{
            request.flushScheduled = !1, currentView && 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = null, writtenBytes = 0);
        }
    }
    0 === request.pendingChunks && (12 > request.status && request.cacheController.abort(Error("This render completed successfully. All cacheSignals are now aborted to allow clean up of any unused resources.")), null !== request.destination && (request.status = 14, request.destination.close(), request.destination = null));
}
function startWork(request) {
    request.flushScheduled = null !== request.destination;
    supportsRequestStorage ? scheduleMicrotask(function() {
        requestStorage.run(request, performWork, request);
    }) : scheduleMicrotask(function() {
        return performWork(request);
    });
    setTimeout(function() {
        10 === request.status && (request.status = 11);
    }, 0);
}
function enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, setTimeout(function() {
        request.flushScheduled = !1;
        flushCompletedChunks(request);
    }, 0));
}
function callOnAllReadyIfReady(request) {
    0 === request.abortableTasks.size && (request = request.onAllReady, request());
}
function startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            flushCompletedChunks(request);
        } catch (error) {
            logRecoverableError(request, error, null), fatalError(request, error);
        }
    }
}
function finishAbort(request, abortedTasks, errorId) {
    try {
        abortedTasks.forEach(function(task) {
            return finishAbortedTask(task, request, errorId);
        });
        var onAllReady = request.onAllReady;
        onAllReady();
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    }
}
function abort(request, reason) {
    if (!(11 < request.status)) try {
        request.status = 12;
        request.cacheController.abort(reason);
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error("The render was aborted by the server without a reason.") : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error("The render was aborted by the server with a promise.") : reason, digest = logRecoverableError(request, error, null), errorId = request.nextChunkId++;
            request.fatalError = errorId;
            request.pendingChunks++;
            emitErrorChunk(request, errorId, digest, error, !1);
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, errorId);
            });
            setTimeout(function() {
                return finishAbort(request, abortableTasks, errorId);
            }, 0);
        } else {
            var onAllReady = request.onAllReady;
            onAllReady();
            flushCompletedChunks(request);
        }
    } catch (error$23) {
        logRecoverableError(request, error$23, null), fatalError(request, error$23);
    }
}
function Chunk(status, value, reason, response) {
    this.status = status;
    this.value = value;
    this.reason = reason;
    this._response = response;
}
Chunk.prototype = Object.create(Promise.prototype);
Chunk.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            resolve(this.value);
            break;
        case "pending":
        case "blocked":
        case "cyclic":
            resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        default:
            reject(this.reason);
    }
};
function createPendingChunk(response) {
    return new Chunk("pending", null, null, response);
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++)(0, listeners[i])(value);
}
function triggerErrorOnChunk(chunk, error) {
    if ("pending" !== chunk.status && "blocked" !== chunk.status) chunk.reason.error(error);
    else {
        var listeners = chunk.reason;
        chunk.status = "rejected";
        chunk.reason = error;
        null !== listeners && wakeChunk(listeners, error);
    }
}
function resolveModelChunk(chunk, value, id) {
    if ("pending" !== chunk.status) chunk = chunk.reason, "C" === value[0] ? chunk.close("C" === value ? '"$undefined"' : value.slice(1)) : chunk.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = id;
        if (null !== resolveListeners) switch(initializeModelChunk(chunk), chunk.status){
            case "fulfilled":
                wakeChunk(resolveListeners, chunk.value);
                break;
            case "pending":
            case "blocked":
            case "cyclic":
                if (chunk.value) for(value = 0; value < resolveListeners.length; value++)chunk.value.push(resolveListeners[value]);
                else chunk.value = resolveListeners;
                if (chunk.reason) {
                    if (rejectListeners) for(value = 0; value < rejectListeners.length; value++)chunk.reason.push(rejectListeners[value]);
                } else chunk.reason = rejectListeners;
                break;
            case "rejected":
                rejectListeners && wakeChunk(rejectListeners, chunk.reason);
        }
    }
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new Chunk("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1, response);
}
function resolveIteratorResultChunk(chunk, value, done) {
    resolveModelChunk(chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1);
}
function loadServerReference$1(response, id, bound, parentChunk, parentObject, key) {
    var serverReference = resolveServerReference(response._bundlerConfig, id);
    id = preloadModule$1(serverReference);
    if (bound) bound = Promise.all([
        bound,
        id
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    });
    else if (id) bound = Promise.resolve(id).then(function() {
        return requireModule(serverReference);
    });
    else return requireModule(serverReference);
    bound.then(createModelResolver(parentChunk, parentObject, key, !1, response, createModel, []), createModelReject(parentChunk));
    return null;
}
function reviveModel(response, parentObj, parentKey, value, reference) {
    if ("string" === typeof value) return parseModelString(response, parentObj, parentKey, value, reference);
    if ("object" === typeof value && null !== value) {
        if (void 0 !== reference && void 0 !== response._temporaryReferences && response._temporaryReferences.set(value, reference), Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = reviveModel(response, value, "" + i, value[i], void 0 !== reference ? reference + ":" + i : void 0);
        else for(i in value)hasOwnProperty.call(value, i) && (parentObj = void 0 !== reference && -1 === i.indexOf(":") ? reference + ":" + i : void 0, parentObj = reviveModel(response, value, i, value[i], parentObj), void 0 !== parentObj ? value[i] = parentObj : delete value[i]);
    }
    return value;
}
var initializingChunk = null, initializingChunkBlockedModel = null;
function initializeModelChunk(chunk) {
    var prevChunk = initializingChunk, prevBlocked = initializingChunkBlockedModel;
    initializingChunk = chunk;
    initializingChunkBlockedModel = null;
    var rootReference = -1 === chunk.reason ? void 0 : chunk.reason.toString(16), resolvedModel = chunk.value;
    chunk.status = "cyclic";
    chunk.value = null;
    chunk.reason = null;
    try {
        var rawModel = JSON.parse(resolvedModel), value = reviveModel(chunk._response, {
            "": rawModel
        }, "", rawModel, rootReference);
        if (null !== initializingChunkBlockedModel && 0 < initializingChunkBlockedModel.deps) initializingChunkBlockedModel.value = value, chunk.status = "blocked";
        else {
            var resolveListeners = chunk.value;
            chunk.status = "fulfilled";
            chunk.value = value;
            null !== resolveListeners && wakeChunk(resolveListeners, value);
        }
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingChunk = prevChunk, initializingChunkBlockedModel = prevBlocked;
    }
}
function reportGlobalError(response, error) {
    response._closed = !0;
    response._closedReason = error;
    response._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(chunk, error);
    });
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._formData.get(response._prefix + id), chunk = null != chunk ? new Chunk("resolved_model", chunk, id, response) : response._closed ? new Chunk("rejected", null, response._closedReason, response) : createPendingChunk(response), chunks.set(id, chunk));
    return chunk;
}
function createModelResolver(chunk, parentObject, key, cyclic, response, map, path) {
    if (initializingChunkBlockedModel) {
        var blocked = initializingChunkBlockedModel;
        cyclic || blocked.deps++;
    } else blocked = initializingChunkBlockedModel = {
        deps: cyclic ? 0 : 1,
        value: null
    };
    return function(value) {
        for(var i = 1; i < path.length; i++)value = value[path[i]];
        parentObject[key] = map(response, value);
        "" === key && null === blocked.value && (blocked.value = parentObject[key]);
        blocked.deps--;
        0 === blocked.deps && "blocked" === chunk.status && (value = chunk.value, chunk.status = "fulfilled", chunk.value = blocked.value, null !== value && wakeChunk(value, blocked.value));
    };
}
function createModelReject(chunk) {
    return function(error) {
        return triggerErrorOnChunk(chunk, error);
    };
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            parentObject = id.value;
            for(key = 1; key < reference.length; key++)parentObject = parentObject[reference[key]];
            return map(response, parentObject);
        case "pending":
        case "blocked":
        case "cyclic":
            var parentChunk = initializingChunk;
            id.then(createModelResolver(parentChunk, parentObject, key, "cyclic" === id.status, response, map, reference), createModelReject(parentChunk));
            return null;
        default:
            throw id.reason;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseTypedArray(response, reference, constructor, bytesPerElement, parentObject, parentKey) {
    reference = parseInt(reference.slice(2), 16);
    reference = response._formData.get(response._prefix + reference);
    reference = constructor === ArrayBuffer ? reference.arrayBuffer() : reference.arrayBuffer().then(function(buffer) {
        return new constructor(buffer);
    });
    bytesPerElement = initializingChunk;
    reference.then(createModelResolver(bytesPerElement, parentObject, parentKey, !1, response, createModel, []), createModelReject(bytesPerElement));
    return null;
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    stream = new Chunk("fulfilled", stream, controller, response);
    chunks.set(id, stream);
    response = response._formData.getAll(response._prefix + id);
    for(id = 0; id < response.length; id++)chunks = response[id], "C" === chunks[0] ? controller.close("C" === chunks ? '"$undefined"' : chunks.slice(1)) : controller.enqueueModel(chunks);
}
function parseReadableStream(response, reference, type) {
    reference = parseInt(reference.slice(2), 16);
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, reference, type, {
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new Chunk("resolved_model", json, -1, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$26 = createPendingChunk(response);
                chunk$26.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$26;
                chunk.then(function() {
                    previousBlockedChunk === chunk$26 && (previousBlockedChunk = null);
                    resolveModelChunk(chunk$26, json, -1);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
    return type;
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function parseAsyncIterable(response, reference, iterator) {
    reference = parseInt(reference.slice(2), 16);
    var buffer = [], closed = !1, nextWriteIndex = 0, $jscomp$compprop2 = {};
    $jscomp$compprop2 = ($jscomp$compprop2[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new Chunk("fulfilled", {
                    done: !0,
                    value: void 0
                }, null, response);
                buffer[nextReadIndex] = createPendingChunk(response);
            }
            return buffer[nextReadIndex++];
        });
    }, $jscomp$compprop2);
    iterator = iterator ? $jscomp$compprop2[ASYNC_ITERATOR]() : $jscomp$compprop2;
    resolveStream(response, reference, iterator, {
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = createPendingChunk(response)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(buffer[nextWriteIndex++], error);
        }
    });
    return iterator;
}
function parseModelString(response, obj, key, value, reference) {
    if ("$" === value[0]) {
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "@":
                return obj = parseInt(value.slice(2), 16), getChunk(response, obj);
            case "F":
                return value = value.slice(2), value = getOutlinedModel(response, value, obj, key, createModel), loadServerReference$1(response, value.id, value.bound, initializingChunk, obj, key);
            case "T":
                if (void 0 === reference || void 0 === response._temporaryReferences) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
                return createTemporaryReference(response._temporaryReferences, reference);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createSet);
            case "K":
                obj = value.slice(2);
                var formPrefix = response._prefix + obj + "_", data = new FormData();
                response._formData.forEach(function(entry, entryKey) {
                    entryKey.startsWith(formPrefix) && data.append(entryKey.slice(formPrefix.length), entry);
                });
                return data;
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
        }
        switch(value[1]){
            case "A":
                return parseTypedArray(response, value, ArrayBuffer, 1, obj, key);
            case "O":
                return parseTypedArray(response, value, Int8Array, 1, obj, key);
            case "o":
                return parseTypedArray(response, value, Uint8Array, 1, obj, key);
            case "U":
                return parseTypedArray(response, value, Uint8ClampedArray, 1, obj, key);
            case "S":
                return parseTypedArray(response, value, Int16Array, 2, obj, key);
            case "s":
                return parseTypedArray(response, value, Uint16Array, 2, obj, key);
            case "L":
                return parseTypedArray(response, value, Int32Array, 4, obj, key);
            case "l":
                return parseTypedArray(response, value, Uint32Array, 4, obj, key);
            case "G":
                return parseTypedArray(response, value, Float32Array, 4, obj, key);
            case "g":
                return parseTypedArray(response, value, Float64Array, 8, obj, key);
            case "M":
                return parseTypedArray(response, value, BigInt64Array, 8, obj, key);
            case "m":
                return parseTypedArray(response, value, BigUint64Array, 8, obj, key);
            case "V":
                return parseTypedArray(response, value, DataView, 1, obj, key);
            case "B":
                return obj = parseInt(value.slice(2), 16), response._formData.get(response._prefix + obj);
        }
        switch(value[1]){
            case "R":
                return parseReadableStream(response, value, void 0);
            case "r":
                return parseReadableStream(response, value, "bytes");
            case "X":
                return parseAsyncIterable(response, value, !1);
            case "x":
                return parseAsyncIterable(response, value, !0);
        }
        value = value.slice(1);
        return getOutlinedModel(response, value, obj, key, createModel);
    }
    return value;
}
function createResponse(bundlerConfig, formFieldPrefix, temporaryReferences) {
    var backingFormData = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : new FormData(), chunks = new Map();
    return {
        _bundlerConfig: bundlerConfig,
        _prefix: formFieldPrefix,
        _formData: backingFormData,
        _chunks: chunks,
        _closed: !1,
        _closedReason: null,
        _temporaryReferences: temporaryReferences
    };
}
function close(response) {
    reportGlobalError(response, Error("Connection closed."));
}
function loadServerReference(bundlerConfig, id, bound) {
    var serverReference = resolveServerReference(bundlerConfig, id);
    bundlerConfig = preloadModule$1(serverReference);
    return bound ? Promise.all([
        bound,
        bundlerConfig
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    }) : bundlerConfig ? Promise.resolve(bundlerConfig).then(function() {
        return requireModule(serverReference);
    }) : Promise.resolve(requireModule(serverReference));
}
function decodeBoundActionMetaData(body, serverManifest, formFieldPrefix) {
    body = createResponse(serverManifest, formFieldPrefix, void 0, body);
    close(body);
    body = getChunk(body, 0);
    body.then(function() {});
    if ("fulfilled" !== body.status) throw body.reason;
    return body.value;
}
function decodeAction$1(body, serverManifest) {
    var formData = new FormData(), action = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_") ? key.startsWith("$ACTION_REF_") ? (value = "$ACTION_" + key.slice(12) + ":", value = decodeBoundActionMetaData(body, serverManifest, value), action = loadServerReference(serverManifest, value.id, value.bound)) : key.startsWith("$ACTION_ID_") && (value = key.slice(11), action = loadServerReference(serverManifest, value, null)) : formData.append(key, value);
    });
    return null === action ? null : action.then(function(fn) {
        return fn.bind(null, formData);
    });
}
function decodeFormState$1(actionResult, body, serverManifest) {
    var keyPath = body.get("$ACTION_KEY");
    if ("string" !== typeof keyPath) return Promise.resolve(null);
    var metaData = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_REF_") && (value = "$ACTION_" + key.slice(12) + ":", metaData = decodeBoundActionMetaData(body, serverManifest, value));
    });
    if (null === metaData) return Promise.resolve(null);
    var referenceId = metaData.id;
    return Promise.resolve(metaData.bound).then(function(bound) {
        return null === bound ? null : [
            actionResult,
            keyPath,
            referenceId,
            bound.length - 1
        ];
    });
}
var serverManifest = {};
exports.createClientReference = function(id, exportName, bundles, importMap) {
    return {
        $$typeof: CLIENT_REFERENCE_TAG$1,
        $$id: id,
        $$name: exportName,
        $$bundles: bundles,
        $$importMap: importMap
    };
};
exports.createTemporaryReferenceSet = function() {
    return new WeakMap();
};
exports.decodeAction = function(body) {
    return decodeAction$1(body, serverManifest);
};
exports.decodeFormState = function(actionResult, body) {
    return decodeFormState$1(actionResult, body, serverManifest);
};
exports.decodeReply = function(body, options) {
    if ("string" === typeof body) {
        var form = new FormData();
        form.append("0", body);
        body = form;
    }
    body = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0, body);
    options = getChunk(body, 0);
    close(body);
    return options;
};
exports.decodeReplyFromAsyncIterable = function(iterable, options) {
    function progress(entry) {
        if (entry.done) close(response);
        else {
            entry = entry.value;
            var name = entry[0];
            entry = entry[1];
            if ("string" === typeof entry) {
                response._formData.append(name, entry);
                var prefix = response._prefix;
                if (name.startsWith(prefix)) {
                    var chunks = response._chunks;
                    name = +name.slice(prefix.length);
                    (chunks = chunks.get(name)) && resolveModelChunk(chunks, entry, name);
                }
            } else response._formData.append(name, entry);
            iterator.next().then(progress, error);
        }
    }
    function error(reason) {
        reportGlobalError(response, reason);
        "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
    }
    var iterator = iterable[ASYNC_ITERATOR](), response = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0);
    iterator.next().then(progress, error);
    return getChunk(response, 0);
};
exports.loadServerAction = function(id) {
    var reference = resolveServerReference(serverManifest, id);
    return Promise.resolve(reference).then(function() {
        return preloadModule$1(reference);
    }).then(function() {
        var fn = requireModule(reference);
        if ("function" !== typeof fn) throw Error("Server actions must be functions");
        return fn;
    });
};
exports.registerServerActions = function(manifest) {
    serverManifest = manifest;
};
exports.registerServerReference = function(reference, id, exportName) {
    return Object.defineProperties(reference, {
        $$typeof: {
            value: SERVER_REFERENCE_TAG
        },
        $$id: {
            value: id + "#" + exportName,
            configurable: !0
        },
        $$bound: {
            value: null,
            configurable: !0
        },
        bind: {
            value: bind,
            configurable: !0
        }
    });
};
exports.renderToReadableStream = function(model, options) {
    var request = new RequestInstance(20, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, noop, noop, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
    if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
            var listener = function() {
                abort(request, signal.reason);
                signal.removeEventListener("abort", listener);
            };
            signal.addEventListener("abort", listener);
        }
    }
    return new ReadableStream({
        type: "bytes",
        start: function() {
            startWork(request);
        },
        pull: function(controller) {
            startFlowing(request, controller);
        },
        cancel: function(reason) {
            request.destination = null;
            abort(request, reason);
        }
    }, {
        highWaterMark: 0
    });
};
exports.unstable_prerender = function(model, options) {
    return new Promise(function(resolve, reject) {
        var request = new RequestInstance(21, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            resolve({
                prelude: stream
            });
        }, reject, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(request, signal.reason);
            else {
                var listener = function() {
                    abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        startWork(request);
    });
};

},{"2381f0f3ff03ff95":"gC2PC","6db66a729b66b575":"a1TxN"}],"gC2PC":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"c4Fud"}],"c4Fud":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.1.0";

},{"6a05e75e64e4f862":"a1TxN"}],"8BIYE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkdownMenu", ()=>MarkdownMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _checkmarkCircle = require("@react-spectrum/s2/icons/CheckmarkCircle");
var _checkmarkCircleDefault = parcelHelpers.interopDefault(_checkmarkCircle);
var _copy = require("@react-spectrum/s2/icons/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _library = require("./library");
var _more = require("@react-spectrum/s2/icons/More");
var _moreDefault = parcelHelpers.interopDefault(_more);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function MarkdownMenu({ url }) {
    let mdUrl = (url ?? '').replace(/\.html?$/i, '') + '.md';
    let [isCopied, setIsCopied] = (0, _react.useState)(false);
    let timeout = (0, _react.useRef)(null);
    let pageUrl = typeof window !== 'undefined' && url ? new URL(url, window.location.origin).href : url ?? '';
    let fullMdUrl = typeof window !== 'undefined' && mdUrl ? new URL(mdUrl, window.location.origin).href : mdUrl;
    let library = url ? (0, _library.getLibraryLabel)((0, _library.getLibraryFromUrl)(url)) : '';
    let aiPrompt = `Answer questions about the following ${library} documentation page: ${pageUrl}\nMarkdown source: ${fullMdUrl}`;
    let chatGptUrl = `https://chatgpt.com/?q=${encodeURIComponent(aiPrompt)}`;
    let claudeUrl = `https://claude.ai/new?q=${encodeURIComponent(aiPrompt)}`;
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    let handleCopy = (0, _react.useCallback)(async ()=>{
        if (timeout.current) clearTimeout(timeout.current);
        if (typeof navigator !== 'undefined' && navigator.clipboard) try {
            let response = await fetch(mdUrl);
            let markdown = await response.text();
            await navigator.clipboard.writeText(markdown);
            setIsCopied(true);
            timeout.current = setTimeout(()=>setIsCopied(false), 2000);
        } catch  {
            (0, _s2.UNSTABLE_ToastQueue).negative('Failed to copy markdown.');
        }
    }, [
        mdUrl
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " sd12 _Ce12 Sp12 Rp12 Qf12",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionButton), {
                isQuiet: true,
                size: "M",
                onPress: handleCopy,
                children: [
                    isCopied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkCircleDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                        children: "Copy for LLM"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                        size: "M",
                        isQuiet: true,
                        "aria-label": "Markdown options",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "view",
                                href: mdUrl,
                                target: "_blank",
                                children: "View as Markdown"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "chatgpt",
                                href: chatGptUrl,
                                target: "_blank",
                                children: "Open in ChatGPT"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "claude",
                                href: claudeUrl,
                                target: "_blank",
                                children: "Open in Claude"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"0":"gLyho","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuTrigger","1F0Yz"],["Text","10r6w"],["UNSTABLE_ToastQueue","9R0uF","ToastQueue"]],"@react-spectrum/s2/icons/CheckmarkCircle":"6hpGX","@react-spectrum/s2/icons/Copy":"6imrL","./library":"a5H2j","@react-spectrum/s2/icons/More":"gP3id","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gLyho":[function() {},{}],"iKE7T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollableToc", ()=>ScrollableToc);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function ScrollableToc({ children }) {
    let [topMaskSize, setTopMaskSize] = (0, _react.useState)(0);
    let [bottomMaskSize, setBottomMaskSize] = (0, _react.useState)(0);
    let scrollRef = (0, _react.useRef)(null);
    let updateMasks = (element)=>{
        let scrollTop = element.scrollTop;
        let scrollHeight = element.scrollHeight;
        let clientHeight = element.clientHeight;
        let distanceFromBottom = scrollHeight - scrollTop - clientHeight;
        setTopMaskSize(Math.min(scrollTop, 32));
        setBottomMaskSize(Math.min(distanceFromBottom, 32));
    };
    (0, _react.useEffect)(()=>{
        if (scrollRef.current) updateMasks(scrollRef.current);
    }, [
        children
    ]);
    let maskImage;
    if (topMaskSize > 0 || bottomMaskSize > 0) {
        let parts = [];
        if (topMaskSize > 0) {
            parts.push('transparent 0px');
            parts.push(`black ${topMaskSize}px`);
        } else parts.push('black 0px');
        if (bottomMaskSize > 0) {
            parts.push(`black calc(100% - ${bottomMaskSize}px)`);
            parts.push('transparent 100%');
        } else parts.push('black 100%');
        maskImage = `linear-gradient(to bottom, ${parts.join(', ')})`;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: scrollRef,
        onScroll: (e)=>updateMasks(e.currentTarget),
        style: {
            maskImage
        },
        className: " Pa12 Ma12",
        children: children
    });
}

},{"0":"l9NJC","react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l9NJC":[function() {},{}],"9Gcxn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "H2", ()=>H2);
parcelHelpers.export(exports, "H3", ()=>H3);
parcelHelpers.export(exports, "H4", ()=>H4);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _link = require("@react-spectrum/s2/icons/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
'use client';
function childrenToString(children) {
    if (typeof children === 'string') return children;
    if (Array.isArray(children)) return children.reduce((p, c)=>p + childrenToString(c), '');
    return '';
}
function anchorId(children) {
    return childrenToString(children).replace(/\s/g, '-').replace(/[^a-zA-Z0-9-_]/g, '').toLowerCase();
}
function AnchorLink({ anchorId, isHovered, level, headingText }) {
    let { isFocusVisible, focusProps } = (0, _focus.useFocusRing)({
        within: true
    });
    const href = `#${anchorId}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        ...focusProps,
        className: function anonymous(props) {
            let rules = " ";
            if (props.isFocusVisible) rules += ' _Ib12';
            else if (props.isHovered) rules += ' _Ib12';
            else rules += ' _Ia12';
            if (props.level === "4") rules += ' Is12';
            else if (props.level === "3") rules += ' Is12';
            else rules += ' Iv12';
            rules += ' YK0XD1b12';
            rules += ' Xb12';
            rules += ' _2b12';
            return rules;
        }({
            isHovered,
            isFocusVisible,
            level
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Link), {
            href: href,
            "aria-label": `Link to ${headingText}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                styles: " Gs12 Zu12 Ft12",
                UNSAFE_style: {
                    marginBottom: level === 3 || level === 4 ? 0 : undefined
                }
            })
        })
    });
}
function H2({ children, ...props }) {
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let id = anchorId(children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
        ...props,
        id: id,
        className: " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-lcY1Ce12 vx12 xe12 _xa12 xX0cczbd12 _xX0cczba12 xezxGHbd12 _xezxGHba12 xfe12 _xfa12 xfX0cczbd12 _xfX0cczba12 xfezxGHbd12 _xfezxGHba12 _Fd12 _FezxGHba12 _FnuYUweb12 po12 JI12 GA12",
        ...hoverProps,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnchorLink, {
                anchorId: id,
                isHovered: isHovered,
                level: 2,
                headingText: children
            })
        ]
    });
}
function H3({ children, ...props }) {
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let id = anchorId(children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
        ...props,
        id: id,
        className: " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-g12 vx12 xe12 _xa12 xX0cczbd12 _xX0cczba12 xezxGHbd12 _xezxGHba12 xfe12 _xfa12 xfX0cczbd12 _xfX0cczba12 xfezxGHbd12 _xfezxGHba12 _Fd12 _FezxGHba12 _FnuYUweb12 po12 JG12 GA12",
        ...hoverProps,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnchorLink, {
                anchorId: id,
                isHovered: isHovered,
                level: 3,
                headingText: children
            })
        ]
    });
}
function H4({ children, ...props }) {
    let { hoverProps, isHovered } = (0, _interactions.useHover)({});
    let id = anchorId(children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
        ...props,
        id: id,
        className: " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-f12 vx12 xe12 _xa12 xX0cczbd12 _xX0cczba12 xezxGHbd12 _xezxGHba12 xfe12 _xfa12 xfX0cczbd12 _xfX0cczba12 xfezxGHbd12 _xfezxGHba12 _Fd12 _FezxGHba12 _FnuYUweb12 po12",
        ...hoverProps,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnchorLink, {
                anchorId: id,
                isHovered: isHovered,
                level: 4,
                headingText: children
            })
        ]
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"42COX","@react-spectrum/s2/icons/Link":"ivjAn","react":"a1TxN","@react-aria/focus":"6TXyU","@react-aria/interactions":"k6FLA","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b3IWk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Header);
var _jsxRuntime = require("react/jsx-runtime");
// @ts-ignore
var _reactDom = require("react-dom");
var _library = require("./library");
var _githubLogo = require("./icons/GithubLogo");
var _githubLogoDefault = parcelHelpers.interopDefault(_githubLogo);
var _reactAriaComponents = require("react-aria-components");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchMenuTrigger = require("./SearchMenuTrigger");
var _searchMenuTriggerDefault = parcelHelpers.interopDefault(_searchMenuTrigger);
'use client';
function getButtonText(currentPage) {
    return (0, _library.getLibraryLabel)((0, _library.getLibraryFromPage)(currentPage));
}
function getButtonIcon(currentPage) {
    return (0, _library.getLibraryIcon)((0, _library.getLibraryFromPage)(currentPage));
}
const libraryStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' Se12';
    rules += ' Re12';
    rules += ' sd12';
    rules += ' _Xa12';
    rules += ' Mk12';
    rules += ' oc12';
    rules += ' nc12';
    rules += ' kc12';
    rules += ' jc12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.isPressed) rules += ' gF12';
    else if (props.isFocusVisible) rules += ' gF12';
    else if (props.isHovered) rules += ' gF12';
    else rules += ' g912';
    rules += ' I1fsDO12';
    return rules;
};
const linkStyle = {
    outlineStyle: {
        "default": "none",
        isFocusVisible: "solid"
    },
    outlineColor: "focus-ring",
    outlineWidth: 2,
    outlineOffset: 2,
    font: 'ui',
    textDecoration: 'none',
    transition: 'default',
    backgroundColor: {
        default: {
            "default": "gray-100",
            isHovered: "gray-100:hovered",
            isFocusVisible: "gray-100:focused",
            isPressed: "gray-100:pressed",
            default: 'transparent'
        }
    },
    height: 32,
    paddingX: 'edge-to-text',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 'lg'
};
const linkStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' uk12';
    rules += ' uch12';
    rules += ' udi12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' -_6BNtrc-c12';
    rules += ' vx12';
    rules += ' xb12';
    rules += ' _xa12';
    rules += ' _Fd12';
    rules += ' _FezxGHba12';
    rules += ' _FnuYUweb12';
    rules += ' pt12';
    rules += ' _Xa12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.isPressed) rules += ' gF12';
    else if (props.isFocusVisible) rules += ' gF12';
    else if (props.isHovered) rules += ' gF12';
    else rules += ' g912';
    rules += ' FRuFGYc12';
    rules += ' Sv12';
    rules += ' Rv12';
    rules += ' sd12';
    rules += ' eb12';
    rules += ' oc12';
    rules += ' nc12';
    rules += ' kc12';
    rules += ' jc12';
    rules += ' -F_-Fx12';
    return rules;
};
const iconStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kd12';
    rules += ' uk12';
    rules += ' uch12';
    rules += ' udi12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' -_6BNtrc-c12';
    rules += ' vx12';
    rules += ' xb12';
    rules += ' _xa12';
    rules += ' _Fd12';
    rules += ' _FezxGHba12';
    rules += ' _FnuYUweb12';
    rules += ' pt12';
    rules += ' _Xa12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    if (props.isPressed) rules += ' gF12';
    else if (props.isFocusVisible) rules += ' gF12';
    else if (props.isHovered) rules += ' gF12';
    else rules += ' g912';
    rules += ' Fx12';
    rules += ' SWJpoB12';
    rules += ' RWJpoB12';
    rules += ' sd12';
    rules += ' eb12';
    rules += ' oc12';
    rules += ' nc12';
    rules += ' kc12';
    rules += ' jc12';
    return rules;
};
function Header(props) {
    const { pages, currentPage } = props;
    const [searchOpen, setSearchOpen] = (0, _react.useState)(false);
    const searchMenuId = (0, _react.useId)();
    let ref = (0, _react.useRef)(null);
    let docsRef = (0, _react.useRef)(null);
    let releasesRef = (0, _react.useRef)(null);
    let blogRef = (0, _react.useRef)(null);
    let openSearchMenu = async ()=>{
        if (!document.startViewTransition) {
            setSearchOpen((prev)=>!prev);
            return;
        }
        // Preload SearchMenu so it is ready to render immediately.
        await (0, _searchMenuTrigger.preloadSearchMenu)();
        document.startViewTransition(()=>{
            (0, _reactDom.flushSync)(()=>{
                setSearchOpen((prev)=>!prev);
            });
        });
    };
    let closeSearchMenu = ()=>{
        if (!document.startViewTransition) {
            setSearchOpen(false);
            return;
        }
        document.startViewTransition(()=>{
            (0, _reactDom.flushSync)(()=>{
                setSearchOpen(false);
            });
        });
    };
    let handleActionButtonKeyDown = (e)=>{
        if (e.key === 'ArrowDown' && !searchOpen) {
            e.preventDefault();
            openSearchMenu();
        }
    };
    let library = (0, _library.getLibraryFromPage)(currentPage);
    let subdirectory = 's2';
    if (library === 'internationalized' || library === 'react-aria') // the internationalized library has no homepage so i've chosen to route it to the react aria homepage
    subdirectory = 'react-aria';
    let homepage = '';
    let docs = '';
    let release = '';
    let blog = '';
    for (let page of pages){
        if (page.name.includes(subdirectory) && page.name.includes('index.html') && !page.name.includes('releases') && !page.name.includes('blog') && !page.name.includes('examples')) homepage = page.url;
        if (page.name.includes(subdirectory) && page.name.includes('getting-started.html')) docs = page.url;
        if (page.name.includes(subdirectory) && page.name.includes('index.html') && page.name.includes('releases')) release = page.url;
        if (page.name.includes('react-aria') && page.name.includes('index.html') && page.name.includes('blog')) blog = page.url;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
            className: " Za12 sk12 spd12 _Ca12",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " Za12 se12 Duowq12 eb12",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " __Ad12",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
                            "aria-label": "Open menu and search",
                            "aria-expanded": searchOpen,
                            "aria-controls": searchOpen ? searchMenuId : undefined,
                            href: homepage,
                            onKeyDown: handleActionButtonKeyDown,
                            // @ts-ignore
                            // onHoverStart={() => preloadSearchMenu()}
                            ref: ref,
                            style: (0, _s2.pressScale)(ref),
                            className: (renderProps)=>libraryStyles({
                                    ...renderProps
                                }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: " sd12 eb12",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: " Js12",
                                        style: {
                                            viewTransitionName: !searchOpen ? 'search-menu-icon' : 'none'
                                        },
                                        children: getButtonIcon(currentPage)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-f12 vx12 xb12 _xa12 _Fd12 _FezxGHba12 _FnuYUweb12 pt12 Iv12",
                                        style: {
                                            viewTransitionName: !searchOpen ? 'search-menu-label' : 'none'
                                        },
                                        children: getButtonText(currentPage)
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchMenuTriggerDefault.default), {
                        pages: pages,
                        currentPage: currentPage,
                        onOpen: openSearchMenu,
                        onClose: closeSearchMenu,
                        isSearchOpen: searchOpen,
                        overlayId: searchMenuId
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " sd12 eb12 Ub12 qb12 __Ac12",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
                                className: (renderProps)=>linkStyles({
                                        ...renderProps
                                    }),
                                href: docs,
                                ref: docsRef,
                                style: (0, _s2.pressScale)(docsRef),
                                children: "Docs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
                                className: (renderProps)=>linkStyles({
                                        ...renderProps
                                    }),
                                href: release,
                                ref: releasesRef,
                                style: (0, _s2.pressScale)(releasesRef),
                                children: "Releases"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
                                className: (renderProps)=>linkStyles({
                                        ...renderProps
                                    }),
                                href: blog,
                                target: subdirectory === 's2' ? '_blank' : '',
                                rel: "noopener noreferrer",
                                ref: blogRef,
                                style: (0, _s2.pressScale)(blogRef),
                                children: "Blog"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
                                "aria-label": "React Spectrum GitHub repo",
                                className: (renderProps)=>iconStyles({
                                        ...renderProps
                                    }),
                                href: "https://github.com/adobe/react-spectrum",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _githubLogoDefault.default), {})
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","7":"4oKuc","8":"4oKuc","9":"4oKuc","react/jsx-runtime":"2Is6Z","react-dom":"gC2PC","./library":"a5H2j","./icons/GithubLogo":"dcOQ5","react-aria-components":"fOCdV","@react-spectrum/s2":"8Ufux","react":"a1TxN","./SearchMenuTrigger":"kwXgr","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dcOQ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: " pm12",
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 19",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M9.969 0C4.457 0 0 4.355 0 9.742c0 4.305 2.855 7.95 6.816 9.238.497.098.676-.207.676-.464 0-.227-.015-1-.015-1.809-2.774.582-3.352-1.16-3.352-1.16-.445-1.129-1.105-1.418-1.105-1.418-.907-.598.066-.598.066-.598 1.008.063 1.535 1 1.535 1 .89 1.485 2.328 1.063 2.906.805.082-.629.348-1.063.63-1.305-2.216-.226-4.544-1.066-4.544-4.804 0-1.067.399-1.938 1.024-2.614-.098-.242-.446-1.242.101-2.582 0 0 .84-.258 2.739 1 .812-.21 1.652-.32 2.492-.32.844 0 1.703.11 2.492.32 1.898-1.258 2.742-1 2.742-1 .543 1.34.2 2.34.098 2.582.644.676 1.023 1.547 1.023 2.614 0 3.738-2.328 4.562-4.554 4.804.363.305.675.887.675 1.805 0 1.309-.015 2.355-.015 2.68 0 .257.183.562.675.464 3.961-1.289 6.82-4.933 6.82-9.238C19.942 4.355 15.47 0 9.97 0m0 0",
            className: " Vh3TDrc12 tloq9qb12",
            style: {
                stroke: 'none',
                fillRule: 'evenodd',
                fillOpacity: 1
            }
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _s2.createIcon)(ForwardRef);

},{"0":"kqkjD","1":"bCkQx","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kqkjD":[function() {},{}],"bCkQx":[function() {},{}],"fM2eg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileHeader", ()=>MobileHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _library = require("./library");
var _menuHamburger = require("@react-spectrum/s2/icons/MenuHamburger");
var _menuHamburgerDefault = parcelHelpers.interopDefault(_menuHamburger);
var _modal = require("../../../@react-spectrum/s2/src/Modal");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _constants = require("./constants");
'use client';
const MobileSearchMenu = /*#__PURE__*/ (0, _react.lazy)(()=>require("9e1014ecc3960d12").then(({ MobileSearchMenu })=>({
            default: MobileSearchMenu
        })));
let fadeOut = "_2av0mc";
let shadow = "XYaG5b";
let fadeIn = "nToi3b";
const animation = {
    animationDuration: '1s',
    animationPlayState: {
        default: 'paused',
        '@supports (animation-timeline: scroll())': 'running'
    },
    animationFillMode: 'both',
    transitionTimingFunction: 'linear'
};
const animationRange = '24px 64px';
function MobileHeader({ toc, pages, currentPage }) {
    let ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        // Tiny polyfill for scroll driven animations.
        // Element must have animationDuration: 1s and animationPlayState: paused.
        if (!CSS.supports('(animation-timeline: scroll())') && ref.current) {
            let [start, end] = animationRange.split(' ').map((v)=>parseInt(v, 10));
            let animations = ref.current.getAnimations({
                subtree: true
            });
            let onScroll = ()=>{
                // Calculate animation time based on percentage of animationRange * duration.
                let time = Math.max(0, Math.min(end, window.scrollY - start) / (end - start)) * 1000;
                for (let animation of animations)animation.currentTime = time;
            };
            window.addEventListener('scroll', onScroll, {
                passive: true
            });
            return ()=>window.removeEventListener('scroll', onScroll);
        }
    }, []);
    let currentLibrary = (0, _library.getLibraryFromPage)(currentPage);
    let icon = (0, _constants.TAB_DEFS)[currentLibrary].icon;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        className: " _Pe12 Wr12 Za12 Te12 Qe12 Se12 Re12 _oa12 sd12 spk12 eb12 Ug12 qg12 _9c12 _Nb12 Pb12 -SQSLJb-gX12 -z0sPGb-g_g12 -_5sGM4c-_nLeasBb12 _eL2Ky12 -aGzJ7c-1Za9w12 -aGzJ7c-Qlsn9mNcQZb12 _fb12 _2d12",
        style: {
            animationName: shadow,
            animationTimeline: 'scroll()',
            animationRange
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " sd12 Ug12 qg12 eb12 _ub12",
                children: [
                    icon,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: " uk12 uch12 udi12 uea12 ugb12 uhd12 uje12 u2NhKxcl12 uic12 -_6BNtrc-f12 vx12 xe12 _xa12 xX0cczbd12 _xX0cczba12 xezxGHbd12 _xezxGHba12 xfe12 _xfa12 xfX0cczbd12 _xfX0cczba12 xfezxGHbd12 _xfezxGHba12 _Fd12 _FezxGHba12 _FnuYUweb12 po12 Jy12 Gy12 _eL2Ky12 -aGzJ7c-1Za9w12 -aGzJ7c-Qlsn9mNcQZb12 _fb12 _2d12",
                        style: toc ? {
                            animationName: fadeOut,
                            animationTimeline: 'scroll()',
                            animationRange
                        } : undefined,
                        children: (0, _constants.TAB_DEFS)[currentLibrary].label
                    })
                ]
            }),
            toc && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " _eL2Ky12 -aGzJ7c-1Za9w12 -aGzJ7c-Qlsn9mNcQZb12 _fb12 _2d12 _Pa12 _EF12 -_7PloMd-CoPtrc12 __Ya12",
                style: {
                    animationName: fadeIn,
                    animationTimeline: 'scroll()',
                    animationRange
                },
                children: toc
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.DialogTrigger), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                        "aria-label": "Navigation",
                        isQuiet: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuHamburgerDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                        size: "fullscreenTakeover",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileSearchMenu, {
                            pages: pages,
                            currentPage: currentPage
                        })
                    })
                ]
            })
        ]
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["DialogTrigger","eu4Kx"]],"./library":"a5H2j","@react-spectrum/s2/icons/MenuHamburger":"bneuv","../../../@react-spectrum/s2/src/Modal":"iUTZq","react":"a1TxN","./constants":"hYP4Q","9e1014ecc3960d12":"ismww","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ismww":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
var _reactDom = require("react-dom");
(0, _reactDom.preinit)(module.bundle.resolve("lBmtU"), {
    as: 'style',
    precedence: 'default'
});
let promise = Promise.all([
    module.bundle.load("aPVyw"),
    module.bundle.load("9f8mp"),
    module.bundle.load("hE5Yu"),
    module.bundle.load("i6te6"),
    module.bundle.load("jkk6G"),
    module.bundle.load("50wqC"),
    module.bundle.load("dZMz1"),
    module.bundle.load("c0VSK"),
    module.bundle.load("lfyA4")
]).then(()=>{
    let originalModule = module.bundle.root("7ohac");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("aPVyw")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("9f8mp")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "stylesheet",
                href: module.bundle.resolve("lBmtU"),
                precedence: "default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("hE5Yu")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("i6te6")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("jkk6G")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("50wqC")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("dZMz1")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("c0VSK")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("lfyA4")
            })
        ]
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ","react-dom":"gC2PC"}],"iKyDQ":[function(require,module,exports,__globalThis) {
/* eslint-env browser */ /* eslint-disable react/react-in-jsx-scope */ /* @jsxRuntime automatic */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResourcesProxy", ()=>createResourcesProxy);
parcelHelpers.export(exports, "waitForCSS", ()=>waitForCSS);
var _jsxRuntime = require("react/jsx-runtime");
function createResourcesProxy(module, esModule, resources, bootstrapScript) {
    if (typeof module === 'function') return createResourcesValueProxy(module, resources, bootstrapScript);
    return new Proxy(module, {
        get (target, prop, receiver) {
            if (prop === '__esModule' && esModule) return true;
            let value = Reflect.get(target, prop, receiver);
            return createResourcesValueProxy(value, resources, bootstrapScript);
        }
    });
}
let cache = new WeakMap();
function createResourcesValueProxy(value, resources, bootstrapScript) {
    if (typeof value === 'function') {
        let cached = cache.get(value);
        if (cached) return cached;
        // Detect reads of `Component.prototype.isReactComponent` or `Component.$$typeof`
        // prior to the function being called as an indication that this is a React component.
        // If so, inject the resources as a sibling of the return value.
        let isReactComponent = false;
        let prototypeProxy;
        if (typeof value.prototype === 'object') prototypeProxy = new Proxy(value.prototype, {
            get (target, prop, receiver) {
                if (prop === 'isReactComponent') isReactComponent = true;
                return Reflect.get(target, prop, receiver);
            }
        });
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                if (prototypeProxy && prop === 'prototype' && Object.getOwnPropertyDescriptor(target, 'prototype').configurable) return prototypeProxy;
                if (prop === '$$typeof') isReactComponent = true;
                if (bootstrapScript && prop === 'bootstrapScript') return bootstrapScript;
                return Reflect.get(target, prop, receiver);
            },
            apply (target, thisArg, args) {
                let result = Reflect.apply(target, thisArg, args);
                if (isReactComponent) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        resources,
                        result
                    ]
                });
                return result;
            }
        });
        cache.set(value, proxy);
        return proxy;
    } else if (value && typeof value === 'object') {
        let cached = cache.get(value);
        if (cached) return cached;
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                let value = Reflect.get(target, prop, receiver);
                return createResourcesValueProxy(value, resources, bootstrapScript);
            }
        });
        cache.set(value, proxy);
        return proxy;
    }
    return value;
}
function waitForCSS(url) {
    return new Promise((resolve, reject)=>{
        if (typeof document === 'undefined') return resolve();
        // Find a link element corresponding to this URL.
        let link = document.querySelector(`link[rel="stylesheet"][href="${CSS.escape(url)}"]`);
        if (!link) return resolve();
        // If the link element already has a stylesheet associated with it, then it is already loaded.
        if (link.sheet) return resolve();
        link.addEventListener('load', ()=>{
            resolve();
        });
        link.addEventListener('error', (e)=>{
            reject(e);
        });
    });
}

},{"react/jsx-runtime":"2Is6Z","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jkfFM":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    module.bundle.load("lfyA4"),
    module.bundle.load("c0VSK"),
    module.bundle.load("dZMz1"),
    module.bundle.load("50wqC"),
    module.bundle.load("jkk6G"),
    module.bundle.load("i6te6"),
    module.bundle.load("hE5Yu"),
    require("bb2b507c43adcc96")(module.bundle.resolve("lBmtU")),
    module.bundle.load("9f8mp"),
    module.bundle.load("aPVyw")
]).then(()=>module.bundle.root('7ohac'));

},{"bb2b507c43adcc96":"819rl"}],"819rl":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"e87h6"}],"e87h6":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"dNwuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisclosureRow", ()=>DisclosureRow);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _chevronRight = require("@react-spectrum/s2/icons/ChevronRight");
var _chevronRightDefault = parcelHelpers.interopDefault(_chevronRight);
var _table = require("./Table");
var _reactAria = require("react-aria");
var _reactStately = require("react-stately");
var _react = require("react");
'use client';
const tableCell = " Td12 Qd12 Sd12 Rd12 _ka12 hb12 hEbDz5a12 ma12 la12 _jf12 iq12 _oa12 sb12 snmv8xi12";
const buttonStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf12';
    else rules += ' _Le12';
    rules += ' Oh12';
    rules += ' _Mc12';
    rules += ' _Kb12';
    rules += ' uk12';
    rules += ' uch12';
    rules += ' udi12';
    rules += ' uea12';
    rules += ' ugb12';
    rules += ' uhd12';
    rules += ' uje12';
    rules += ' u2NhKxcl12';
    rules += ' uic12';
    rules += ' -_6BNtrc-c12';
    rules += ' vx12';
    rules += ' xd12';
    rules += ' _xa12';
    rules += ' xX0cczbc12';
    rules += ' _xX0cczba12';
    rules += ' xfd12';
    rules += ' _xfa12';
    rules += ' xfX0cczbc12';
    rules += ' _xfX0cczba12';
    rules += ' _Fd12';
    rules += ' _FezxGHba12';
    rules += ' _FnuYUweb12';
    rules += ' pt12';
    rules += ' Za12';
    rules += ' Fb12';
    if (props.isExpanded) {
        if (props.isPressed) rules += ' gE12';
        else if (props.isFocusVisible) rules += ' gF12';
        else if (props.isHovered) rules += ' gF12';
        else rules += ' gH12';
    } else if (props.isPressed) rules += ' gE12';
    else if (props.isFocusVisible) rules += ' gH12';
    else if (props.isHovered) rules += ' gH12';
    else rules += ' g912';
    rules += ' _ka12';
    rules += ' ha12';
    rules += ' ma12';
    rules += ' la12';
    rules += ' Sf12';
    rules += ' Rf12';
    rules += ' Tt12';
    rules += ' Qt12';
    rules += ' sd12';
    rules += ' eb12';
    rules += ' Ub12';
    rules += ' qb12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' _Wd12';
    rules += ' __ca12';
    return rules;
};
const chevronStyles = function anonymous(props) {
    let rules = " ";
    if (props.isExpanded) rules += ' _Sd12';
    else if (props.isRTL) rules += ' _Sc12';
    rules += ' Yd12';
    rules += ' Xb12';
    rules += ' _2b12';
    rules += ' _va12';
    rules += ' -_8sjo0b-tf12';
    rules += ' Zu12';
    rules += ' Ft12';
    return rules;
};
function DisclosureRow({ title, children, defaultExpanded }) {
    let state = (0, _reactStately.useDisclosureState)({
        defaultExpanded
    });
    let ref = (0, _react.useRef)(null);
    let { buttonProps } = (0, _reactAria.useDisclosure)({}, state, ref);
    delete buttonProps['aria-controls']; // there is no panel element in this implementation
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableBody), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    colSpan: 3,
                    className: tableCell,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Button), {
                        ...buttonProps,
                        className: (p)=>buttonStyles({
                                ...p,
                                isExpanded: state.isExpanded
                            }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronRightDefault.default), {
                                styles: chevronStyles({
                                    isExpanded: state.isExpanded
                                })
                            }),
                            title
                        ]
                    })
                })
            }),
            state.isExpanded && children
        ]
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","react/jsx-runtime":"2Is6Z","react-aria-components":"9G5XO","@react-spectrum/s2/icons/ChevronRight":"kmqkh","./Table":"fiXwD","react-aria":"fRMYk","react-stately":"djrKJ","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = (overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk12';
        rules += ' uch12';
        rules += ' udi12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "L") {
        rules += ' uk12';
        rules += ' uch12';
        rules += ' udi12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "S") {
        rules += ' uk12';
        rules += ' uch12';
        rules += ' udi12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else if (props.size === "XS") {
        rules += ' uk12';
        rules += ' uch12';
        rules += ' udi12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    } else {
        rules += ' uk12';
        rules += ' uch12';
        rules += ' udi12';
        rules += ' uea12';
        rules += ' ugb12';
        rules += ' uhd12';
        rules += ' uje12';
        rules += ' u2NhKxcl12';
        rules += ' uic12';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e12';
        rules += ' vx12';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d12';
        rules += ' vx12';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b12';
        rules += ' vx12';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a12';
        rules += ' vx12';
    } else {
        rules += ' -_6BNtrc-c12';
        rules += ' vx12';
    }
    if (props.size === "XL") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "L") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "S") {
        rules += ' xb12';
        rules += ' _xa12';
    } else if (props.size === "XS") {
        rules += ' xb12';
        rules += ' _xa12';
    } else {
        rules += ' xb12';
        rules += ' _xa12';
    }
    if (props.size === "XL") {
        rules += ' _Fd12';
        rules += ' _FezxGHba12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "L") {
        rules += ' _Fd12';
        rules += ' _FezxGHba12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "S") {
        rules += ' _Fd12';
        rules += ' _FezxGHba12';
        rules += ' _FnuYUweb12';
    } else if (props.size === "XS") {
        rules += ' _Fd12';
        rules += ' _FezxGHba12';
        rules += ' _FnuYUweb12';
    } else {
        rules += ' _Fd12';
        rules += ' _FezxGHba12';
        rules += ' _FnuYUweb12';
    }
    if (props.fillStyle === "outline") rules += ' pm12';
    else if (props.fillStyle === "subtle") rules += ' pm12';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg12';
        else if (props.variant === "chartreuse") rules += ' pg12';
        else if (props.variant === "yellow") rules += ' pg12';
        else if (props.variant === "orange") rules += ' pg12';
        else if (props.variant === "notice") rules += ' pg12';
        else rules += ' px12';
    }
    rules += ' sd12';
    rules += ' ea12';
    rules += ' egLWx3bb12';
    rules += ' _oa12';
    rules += ' Sv12';
    rules += ' SgLWx3bd12';
    rules += ' Rv12';
    rules += ' RgLWx3bd12';
    if (props.size === "XL") {
        if (!minWidth) rules += ' Nl12';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' Nj12';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' Nf12';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' Ne12';
    } else if (!minWidth) rules += ' Nk12';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec12';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn12';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b12';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd12';
    else rules += ' -SFnbic-_Jb12';
    rules += ' -Bu7z1c-ob12';
    rules += ' oj12';
    rules += ' nj12';
    rules += ' kj12';
    rules += ' jj12';
    rules += ' qc12';
    rules += ' qsd12';
    rules += ' -Qg41Lb-IAxCW0c12';
    rules += ' -Qg41Lb-gLWx3bIy12';
    rules += ' MAyFGYc12';
    rules += ' Td12';
    rules += ' Qd12';
    rules += ' -aRvJDd-Tu7Fubd12';
    rules += ' _Ca12';
    if (props.fillStyle === "outline") rules += ' g_g12';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f12';
        else if (props.variant === "cinnamon") rules += ' gP12';
        else if (props.variant === "brown") rules += ' gO12';
        else if (props.variant === "turquoise") rules += ' gy12';
        else if (props.variant === "pink") rules += ' gT12';
        else if (props.variant === "magenta") rules += ' gS12';
        else if (props.variant === "fuchsia") rules += ' gR12';
        else if (props.variant === "purple") rules += ' gM12';
        else if (props.variant === "indigo") rules += ' gK12';
        else if (props.variant === "blue") rules += ' gG12';
        else if (props.variant === "cyan") rules += ' gC12';
        else if (props.variant === "seafoam") rules += ' gz12';
        else if (props.variant === "green") rules += ' gA12';
        else if (props.variant === "celery") rules += ' gv12';
        else if (props.variant === "chartreuse") rules += ' gJ12';
        else if (props.variant === "yellow") rules += ' gW12';
        else if (props.variant === "orange") rules += ' gV12';
        else if (props.variant === "red") rules += ' gU12';
        else if (props.variant === "gray") rules += ' gI12';
        else if (props.variant === "negative") rules += ' gU12';
        else if (props.variant === "notice") rules += ' gV12';
        else if (props.variant === "positive") rules += ' gA12';
        else if (props.variant === "neutral") rules += ' gI12';
        else if (props.variant === "informative") rules += ' gG12';
        else if (props.variant === "accent") rules += ' gG12';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm12';
        else if (props.variant === "cinnamon") rules += ' gq12';
        else if (props.variant === "brown") rules += ' gn12';
        else if (props.variant === "turquoise") rules += ' g512';
        else if (props.variant === "pink") rules += ' gx12';
        else if (props.variant === "magenta") rules += ' gD12';
        else if (props.variant === "fuchsia") rules += ' gr12';
        else if (props.variant === "purple") rules += ' go12';
        else if (props.variant === "indigo") rules += ' gl12';
        else if (props.variant === "blue") rules += ' g212';
        else if (props.variant === "cyan") rules += ' gk12';
        else if (props.variant === "seafoam") rules += ' g412';
        else if (props.variant === "green") rules += ' g112';
        else if (props.variant === "celery") rules += ' g712';
        else if (props.variant === "chartreuse") rules += ' gp12';
        else if (props.variant === "yellow") rules += ' gN12';
        else if (props.variant === "orange") rules += ' gQ12';
        else if (props.variant === "red") rules += ' gB12';
        else if (props.variant === "gray") rules += ' g612';
        else if (props.variant === "negative") rules += ' gB12';
        else if (props.variant === "notice") rules += ' gQ12';
        else if (props.variant === "positive") rules += ' g112';
        else if (props.variant === "neutral") rules += ' g612';
        else if (props.variant === "informative") rules += ' g212';
        else if (props.variant === "accent") rules += ' g212';
    }
    rules += ' _jf12';
    rules += ' _kJ8iPYd12';
    rules += ' hXMFGYc12';
    rules += ' mc12';
    rules += ' lc12';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS12';
        else if (props.variant === "notice") rules += ' i9VrKkd12';
        else if (props.variant === "positive") rules += ' ip17Jm12';
        else if (props.variant === "neutral") rules += ' i0ruhAb12';
        else if (props.variant === "informative") rules += ' iG1ze4d12';
        else if (props.variant === "accent") rules += ' iG1ze4d12';
    } else rules += ' iA12';
    rules += ' -_8sjo0b-t5ZbAob12';
    if (props.size === "XL") rules += ' -M_-Mk12';
    else if (props.size === "L") rules += ' -M_-Mh12';
    else if (props.size === "S") rules += ' -M_-Mg12';
    else if (props.size === "XS") rules += ' -M_-Mf12';
    else rules += ' -M_-Mi12';
    rules += ' -_k_-_kc12';
    rules += ' -h_-hc12';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG12';
                        rules += ' QAzEcG12';
                        rules += ' _Jb12';
                        rules += ' _Nc12';
                        rules += ' Pc12';
                        rules += ' _Yb12';
                        if (props.overflowMode === "wrap") rules += ' _7b12';
                        else if (props.overflowMode === "truncate") rules += ' _7c12';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _reactAriaComponents.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja12"
                    }),
                    styles: " ZuUmpre12 FuUmpre12 I67logd12 _va12"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _utils.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components":[["Provider","bA6Cz"],["TextContext","jt9fm"]],"@react-aria/utils":"3upVm","./Icon":"jQAJE","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}]},[], null, "parcelRequire7f0c", {}, "./", "https://reactspectrum.blob.core.windows.net/reactspectrum/4d73ffd50ea46f5b4b218f822ecec8ff27973eb7/s2-docs/")

//# sourceMappingURL=error.5a5f1cc6.js.map
